import React from "react";
import { Image } from "antd";
import { Row, Text, View, Icon, Graph, Button, Alert } from "../../Components";
import { Modal, Spin } from "antd";
import {
  Metrics,
  Helpers,
  Colors,
  Spacing,
  channelColors as colors,
  Fonts,
  months,
  Images,
} from "../../global";
import { useEffect, useState, useRef, useLayoutEffect } from "react";
import { useRecoilState } from "recoil";
import { allSitesAtom } from "../../Atoms/allSitesAtom";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { useMatch } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  ToolTypes,
  getLiveGraphData,
  addGraphLiveData,
  updateToolSettings,
  saveSession,
  exportFile,
  newSheet,
  clearAlert as clearAlertAPI,
  clearAlerts as clearAlertsAPI,
  deleteAlerts as deleteAlertsAPI,
  addAlert as addAlertAPI,
  updateAlert,
  getAlerts,
} from "../../API";
import { THP, SA4C, ST4C, SSS1, SCP1, SDP1 } from "../../Tools";
import {
  THP_ENABLED_ARRAY,
  THP_CHANNEL_ICONS,
  THP_DEFAULT_Y_AXIS,
  THP_CH_ENUM,
  THP_ENABLED_CHANNELS,
} from "../../Tools/THP";
import {
  SDP1_ENABLED_ARRAY,
  SDP1_CHANNEL_ICONS,
  SDP1_DEFAULT_Y_AXIS,
  SDP1_CH_ENUM,
  SDP1_ENABLED_CHANNELS,
} from "../../Tools/SDP1";
import {
  ST4C_ENABLED_ARRAY,
  ST4C_CHANNEL_ICONS,
  ST4C_DEFAULT_Y_AXIS,
  ST4C_CH_ENUM,
  ST4C_ENABLED_CHANNELS,
} from "../../Tools/ST4C";
import {
  SA4C_ENABLED_ARRAY,
  SA4C_CHANNEL_ICONS,
  SA4C_DEFAULT_Y_AXIS,
  SA4C_CH_ENUM,
  SA4C_ENABLED_CHANNELS,
} from "../../Tools/SA4C";
import {
  SSS1_ENABLED_ARRAY,
  SSS1_CHANNEL_ICONS,
  SSS1_DEFAULT_Y_AXIS,
  SSS1_CH_ENUM,
  SSS1_ENABLED_CHANNELS,
} from "../../Tools/SSS1";
import {
  SCP1_ENABLED_ARRAY,
  SCP1_CHANNEL_ICONS,
  SCP1_DEFAULT_Y_AXIS,
  SCP1_CH_ENUM,
  SCP1_ENABLED_CHANNELS,
  SCP1_GRAPH_INFO,
} from "../../Tools/SCP1";
import HelperService from "../../Helpers/HelperService";
import { useCookies } from "react-cookie";
import { ResponsiveLine } from "@nivo/line";
import "./Site.css";
import { useGoogleLogin } from "@react-oauth/google";
import dayjs from "dayjs";
import {
  Chart as ChartJS,
  TimeScale,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import "chartjs-adapter-date-fns";
import zoomPlugin from "chartjs-plugin-zoom";
import _ from "lodash";
import { Line, Bar } from "react-chartjs-2";
import { ReactComponent as leftIcon } from "../../Assets/SVG/Left.svg";
import { ReactComponent as rightIcon } from "../../Assets/SVG/Right.svg";
import { ReactComponent as clockIcon } from "../../Assets/SVG/TimeAxis_Small.svg";
import { ReactComponent as startIcon } from "../../Assets/SVG/TimeStart_Small.svg";
import { ReactComponent as endIcon } from "../../Assets/SVG/TimeEnd_Small.svg";
import { ReactComponent as fileIcon } from "../../Assets/SVG/File.svg";
import { ReactComponent as sliderIcon } from "../../Assets/SVG/Slider.svg";
import { ReactComponent as closeIcon } from "../../Assets/SVG/Close.svg";
import { ReactComponent as pending } from "../../Assets/SVG/Pending.svg";
import { ReactComponent as alertIcon } from "../../Assets/SVG/Alert.svg";
import { ReactComponent as emailIcon } from "../../Assets/SVG/Email.svg";
import { ReactComponent as phoneIcon } from "../../Assets/SVG/Phone.svg";
import { ReactComponent as alertEditIcon } from "../../Assets/SVG/AlertEdit.svg";
import { ReactComponent as alertRemoveIcon } from "../../Assets/SVG/AlertRemove.svg";
import { ReactComponent as channelIcon } from "../../Assets/SVG/Channel.svg";
import { ReactComponent as criteriaIcon } from "../../Assets/SVG/Criteria.svg";
import { ReactComponent as valueIcon } from "../../Assets/SVG/Value.svg";
import { ReactComponent as messageIcon } from "../../Assets/SVG/Messages.svg";
import ToolSettings from "../../Pages/ToolSettings";

ChartJS.register(
  TimeScale,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  zoomPlugin
);
const previewWidth = 400;
const previewHeight = 200;
let defaultEn = [true, true, true, true, true, true];
let defaultEnAxis = [true, true, true, true, true, true];
let graphPropsDashboard = {
  enX: true,
  start: null,
  end: null,
  en: defaultEn,
  enY: defaultEnAxis,
  enYCount: 0,
  currZoom: { x: 0, scale: 1 },
  customScope: false,
};
const maxAttributes = 8;
let file;
let fileRaw;
let attributes;
let xdata = [];
let multiplier = (previewWidth - 20) / (xdata.length - 1);
let data = Array.from(Array(maxAttributes), () => new Array(0));
let channels = new Array(maxAttributes);
let dataRaw = Array.from(Array(maxAttributes), () => new Array(0));
let yAxisEnabledCount = 0;
let newTouchPosition = -1;
let lastZoomPosition = -1;
let zoomStartIndex = -1;
let zoomEndIndex = -1;
let zoomScale = 1;
let icons;
let tempUnits = Array.from(Array(maxAttributes), () => "");
let goingToGraphProps = false;
let tempScopeAdjustment;
let graphDataPulled = false;
let tempData = [];
let TOOL_CH_ENUM = [];
let attributeArray;
let verticalLines = [];
const formatList = ["Stratus File", "CSV", "Excel XLSX", "PDF", "Google Sheet"];
let moving = false;
let panning = false;
let zooming = false;
let currSlider = 0; // 0=start 1=end
let tempPositionX = undefined;
let tempPositionY = undefined;
let min;
let max;
let enabledChannels;
let tempChannelSelector = {};
let newChannelArray = [];
let selectedTemp = [];
let currentAlertId;
let updateCurrentAlert = false;
let channelNames = [];
let channelUnits = [];
let channelValues = [];
const criteriaList = ["Greater than", "Less than"];
const alertTypeList = ["Single", "Continuous"];
const alertModeList = [
  "Sensor Alert",
  "Power Disconnect Alert",
  "Low Battery Alert",
  "Tool Offline Alert",
];
let lastWidth;
let lastHeight;

const styles = {
  buttons: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  scopeButton: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
  },
  scopeButtons: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  lightRowVertical: {
    borderBottomWidth: 1,
    borderTopWidth: 1,
    borderColor: Colors.light,
  },
  lightRow: {
    borderBottomWidth: 1,
    borderColor: Colors.light,
  },
};

function Site() {
  console.log("SiteWDYR Re-Render! - We don't want this to happen too often.");
  const addSelected = (id) => {
    if (_.isEmpty(selectedTemp)) {
      setSelectMode(true);
    }
    selectedTemp.push(id);
    if (!_.isEqual(selectedTemp, selected)) setSelected(selectedTemp);
    setSelectedCount(selectedTemp.length);
    setLastSelected(id);
  };
  const removeSelected = (id) => {
    let index = selectedTemp.indexOf(id);
    selectedTemp.splice(index, 1);
    if (_.isEmpty(selectedTemp)) {
      setSelectMode(false);
    }
    if (!_.isEqual(selectedTemp, selected)) setSelected(selectedTemp);
    setSelectedCount(selectedTemp.length);
    setLastSelected(id);
  };
  const navToExport = () => {
    console.log("DATA TO EXPORT!");

    // setStartTimeExport(_.cloneDeep(startTime))
    // setStopTimeExport(_.cloneDeep(stopTime))
    now = new Date();
    setName(
      tool.settings.toolName + "_" + (now.getMonth() + 1) + "-" + now.getDate()
    );
    min = graphData.normalData[0][0].toFixed(0);
    max = graphData.normalData[graphData.normalData.length - 1][0].toFixed(0);
    let sliderStart = HelperService.getEpoch(startTime);
    let sliderStop = HelperService.getEpoch(stopTime);
    console.log(
      "sliderStart:",
      sliderStart,
      "sliderStop:",
      sliderStop,
      "min:",
      min,
      "max:",
      max
    );
    updateSliderTime(sliderStart, true);
    updateSliderTime(sliderStop, false);
    newChannelArray = [];
    Object.keys(tempChannelSelector).forEach((channel) => {
      if (tempChannelSelector[channel]) newChannelArray.push(channel);
    });
    setChannelSelector(tempChannelSelector);
    setSelectedChannels(newChannelArray);
    setShowExport(true);
  };
  const CustomPoint = (props) => {
    const { currentSlice } = props;
    console.log("CustomPoint props:", props);
    // it will show the current point
    if (currentSlice && !panning && !zooming) {
      return (
        <g>
          <line
            x1={currentSlice.points[0].x}
            x2={currentSlice.points[0].x}
            y1={0}
            y2={height}
            stroke={Colors.lightGrey}
            strokeWidth="1"
            strokeDasharray={[6, 3]}
          />
          {currentSlice.points.map((point) => (
            <circle
              fill={Colors.darkGrey}
              r={2}
              strokeWidth={1}
              stroke={Colors.darkGrey}
              fillOpacity={1}
              cx={point.x}
              cy={point.y}
            />
          ))}
        </g>
      );
    }
  };
  const updateGraphProps = () => {
    console.log(
      " UPDATING GRAPH PROPS:",
      graphPropsDashboard,
      "enabledAxis",
      enabledAxis,
      "xAxis",
      xAxis
    );
    // if(enalbledYAxisCount!=graphProps.enYCount) {
    //     yAxisEnabledCount = 0
    //     enabledAxis.forEach((axis,index) => {
    //         console.log("current axis:",axis)
    //         if(_.has(axis,'enabled') && axis.enabled && axis.channels.some((channel)=>enabled[channel])) yAxisEnabledCount++
    //     })
    //     if(enalbledYAxisCount == yAxisEnabledCount){
    //         //Data on cloud is wrong
    //     }else{
    //         setEnalbledYAxisCount(yAxisEnabledCount)
    //     }

    // }
    let tempAxis = [...enabledAxis];
    let updateAxis = false;
    enabledAxis.forEach((axis, index) => {
      if (axis != graphPropsDashboard?.enY[index]) {
        tempAxis[index] = graphPropsDashboard?.enY[index];
        updateAxis = true;
      }
    });
    if (updateAxis) {
      if (!_.isEqual(tempAxis, enabledAxis)) setEnabledAxis(tempAxis);
    }
    if (xAxis != graphPropsDashboard.enX) {
      setXAxis(graphPropsDashboard.enX);
    }
    if (customStartTime != graphPropsDashboard.start) {
      setCustomStartTime(graphPropsDashboard.start);
    }
    if (customStopTime != graphPropsDashboard.end) {
      setCustomStopTime(graphPropsDashboard.end);
    }
  };

  function errorCheck() {
    let errorsFound = false;
    if (emailEnabled && emailAddress == "") {
      errorsFound = true;
      setError("Required");
    }
    if (errorsFound) {
      return false;
    }
    return true;
  }

  function updateChannel(key, value) {
    console.log("UpdateChannel key:", key, " value:", value);

    tempChannelSelector = channelSelector;
    console.log("Before:", tempChannelSelector);
    _.set(tempChannelSelector, key, value);
    console.log("After:", tempChannelSelector);
    newChannelArray = [];
    Object.keys(tempChannelSelector).forEach((channel) => {
      if (tempChannelSelector[channel]) newChannelArray.push(channel);
    });
    console.log("newChannelArray:", newChannelArray);
    setChannelSelector(tempChannelSelector);
    setSelectedChannels(newChannelArray);
  }
  const getGraphData = (dataID, scope, attributeArray, allSites) => {
    let graphStore = "";
    switch (scope) {
      case "all":
        graphStore = "maxScope";
        break;
      case "day":
        graphStore = "dayScope";
        break;
      case "week":
        graphStore = "weekScope";
        break;
      case "month":
        graphStore = "monthScope";
        break;
      case "live":
        graphStore = "liveScope";
        break;
      case "custom":
        graphStore = "customScope";
        break;
      default:
        break;
    }
    console.log("scope:", scope);
    console.log("state:", allSites);
    console.log("graphStore:", graphStore);
    const tempGraphData = _.get(allSites, graphStore, {});
    console.log("tempGraphData:", tempGraphData);
    let myGraphData;
    if (!_.isEmpty(tempGraphData)) {
      //Go through the list of tools
      tempGraphData.forEach((toolData, key) => {
        //find the tool in the state
        if (_.isEqual(key, dataID)) {
          myGraphData = toolData.normalData;
          setGraphData(toolData);
          setStartOfData(toolData.startOfData);
          console.log("CURRENT GRAPH DATA:", toolData);
          // _.assign(myGraphData, toolData)//assign to returned tool object
        }
      });
    }
    console.log("myGraphData:", myGraphData);
    if (myGraphData == undefined) return [];
    let convertedItems = [];
    xdata = [];
    attributeArray.forEach((attribute, i) => {
      let currentData = [];
      if (i > 0) {
        convertedItems[i - 1] = {
          id: attribute,
          color: colors[i - 1],
          data: [],
        };
        myGraphData.forEach((item, index) => {
          let date = new Date(item[0] * 1000);
          if (isNaN(Number(item[i]))) {
            currentData.push({ x: date, y: null });
          } else {
            currentData.push({ x: date, y: item[i] });
          }
          if (i == 1) xdata.push(item[0]);
        });
        console.log("currentData:", currentData);
        convertedItems[i - 1]["data"] = currentData;
      }
    });
    setXdataZoomed(xdata);
    setChartUpdated(true);
    console.log("xdata length:", xdata.length);
    multiplier = (previewWidth - 20) / (xdata.length - 1);
    console.log("convertedItems:", convertedItems);

    return convertedItems;
  };
  const match = useMatch("/site/:mac");
  const macAddress = match?.params.mac;
  console.log("SITE MACADDRESS:", macAddress);
  const { user } = useAuthenticator((context) => [context.user]);
  let email = "";
  if (user?.attributes?.email) email = user?.attributes?.email;
  const [allSites, setAllSites] = useRecoilState(allSitesAtom);
  console.log("Email:", user?.attributes?.email);
  console.log("AllSites:", allSites);
  const currentTool = Object.values(allSites)
    .flatMap((arr) => arr)
    .find((obj) =>
      obj?.mac
        ? obj.mac === macAddress
        : obj?.share_id
        ? obj.share_id === macAddress
        : null
    );
  const ref = useRef();
  const ref2 = useRef();
  const [width, setWidth] = useState(lastWidth);
  const [loading, setLoading] = useState(true);
  const [showGraphProps, setShowGraphProps] = useState(false);
  const [showExport, setShowExport] = useState(false);
  const [height, setHeight] = useState(lastHeight);
  const [displayData, setDisplayData] = useState([]);
  const [displayDataZoomed, setDisplayDataZoomed] = useState([]);
  const [chartUpdated, setChartUpdated] = useState(true);
  const [cookies, setCookie] = useCookies([email]);
  const [customScope, setCustomScope] = useState(false);
  const [xAxis, setXAxis] = useState(true);
  if (macAddress != undefined && cookies[email]?.mac != macAddress)
    setCookie(email, { ...cookies[email], mac: macAddress });
  console.log("Cookies:", cookies);
  let tool = _.cloneDeep(currentTool);

  if (tool?.toolType && enabledChannels == undefined) {
    if (!ToolTypes.THP.localeCompare(tool.toolType)) {
      enabledChannels = THP_ENABLED_CHANNELS(tool, false);
    } else if (!ToolTypes.SDP.localeCompare(tool.toolType)) {
      enabledChannels = SDP1_ENABLED_CHANNELS(tool, false);
    } else if (!ToolTypes.THERMO_4_CH.localeCompare(tool.toolType)) {
      enabledChannels = ST4C_ENABLED_CHANNELS(tool, false);
    } else if (!ToolTypes.ANALOG_4_CH.localeCompare(tool.toolType)) {
      enabledChannels = SA4C_ENABLED_CHANNELS(tool, false);
    } else if (!ToolTypes.SWIM.localeCompare(tool.toolType)) {
      enabledChannels = SSS1_ENABLED_CHANNELS(tool, false);
    } else if (!ToolTypes.CHEM.localeCompare(tool.toolType)) {
      enabledChannels = SCP1_ENABLED_CHANNELS(tool, false);
    }
    tempChannelSelector = {};
    enabledChannels.forEach((channel) => {
      _.set(tempChannelSelector, channel, true);
    });
  }
  const handleSetAllSites = async (tempAllSites) => {
    await setAllSites(() => {
      return tempAllSites;
    });
  };

  const [recipient, setRecipient] = useState(
    tool?.share_id ? allSites["recipientShares"][macAddress] : null
  );
  let now = new Date();
  const [graphData, setGraphData] = useState({
    startOfData: 1690394385,
    data_id_createdAt: 1690394385,
    totalRecordCount: 0,
    updatedAt: HelperService.getEpoch(new Date()),
    data: [],
    rawData: [],
    convertedData: [],
    normalData: [],
  });
  const [toggle, setToggle] = useState(true);
  const [tab, setTab] = useState(0);
  const [noScroll, setNoScroll] = useState(false);
  // const [stats,setStats] = useState([[null,null,null],[null,null,null],[null,null,null],[null,null,null],[null,null,null]])//getStats())
  const [enabled, setEnabled] = useState(
    graphPropsDashboard.en
      ? graphPropsDashboard.en.map((attribute) => attribute)
      : defaultEn
  );
  // const [zoom, setZoom] = useState(false)
  // const [positionX, setPositionX] = useState(-1);// The currently selected X coordinate position
  // const [positionY, setPositionY] = useState(-1);// The currently selected X coordinate position
  const [xdataZoomed, setXdataZoomed] = useState(xdata);
  // const [dataZoomed,setDataZoomed] = useState(data)
  // const [dataRawZoomed,setDataRawZoomed] = useState(dataRaw)
  const [fullscreen, setFullscreen] = useState(false);
  // const [time,setTime] = useState(graphData.updatedAt)
  const [startOfData, setStartOfData] = useState(graphData.startOfData);
  const [scope, setScope] = useState(
    graphPropsDashboard.customScope ? "custom" : "live"
  );
  const [scopeAdjustment, setScopeAdjustment] = useState({
    live: 0,
    day: 0,
    week: 0,
    month: 0,
    all: 0,
    custom: 0,
  });
  const [startTime, setStartTime] = useState(
    displayDataZoomed[0]?.data != undefined &&
      displayDataZoomed[0]?.data.length > 0 &&
      displayDataZoomed[0]?.data[0]?.x != undefined
      ? displayDataZoomed[0]["data"][0]["x"]
      : undefined
  );
  const [customStartTime, setCustomStartTime] = useState(
    startTime ? startTime : new Date()
  );
  const [startTimePicker, setStartTimePicker] = useState(false);
  const [startDatePicker, setStartDatePicker] = useState(false);
  const [stopTime, setStopTime] = useState(
    displayDataZoomed[0]?.data[displayDataZoomed[0]?.data.length - 1] !=
      undefined
      ? displayDataZoomed[0]["data"][displayDataZoomed[0]?.data.length - 1]["x"]
      : undefined
  );
  const [customStopTime, setCustomStopTime] = useState(
    stopTime ? stopTime : new Date()
  );
  const [stopTimePicker, setStopTimePicker] = useState(false);
  const [stopDatePicker, setStopDatePicker] = useState(false);
  const [enabledAxis, setEnabledAxis] = useState(graphPropsDashboard.enY);
  const [name, setName] = useState("");
  const [channelSelector, setChannelSelector] = useState(tempChannelSelector);
  const [selectedChannels, setSelectedChannels] = useState(enabledChannels);
  const [saveLoading, setSaveLoading] = useState(false);
  const [format, setFormat] = useState(0);
  const [exportLoading, setExportLoading] = useState(false);
  const [exportInitiated, setExportInitiated] = useState(false);
  const [sheetLoading, setSheetLoading] = useState(false);
  if (tempPositionX == undefined) tempPositionX = 0; // The currently selected X coordinate position
  if (tempPositionY == undefined) tempPositionY = xdata.length - 1; // The currentl
  const [startTimeExport, setStartTimeExport] = useState(startTime);
  const [stopTimeExport, setStopTimeExport] = useState(stopTime);
  const [startTimeExportPicker, setStartTimeExportPicker] = useState(false);
  const [startDateExportPicker, setStartDateExportPicker] = useState(false);
  const [stopTimeExportPicker, setStopTimeExportPicker] = useState(false);
  const [stopDateExportPicker, setStopDateExportPicker] = useState(false);
  const [positionX, setPositionX] = useState(tempPositionX); // The currently selected X coordinate position
  const [positionY, setPositionY] = useState(tempPositionY); // The currently selected X coordinate position
  // const [verticalLines, setVerticalLines] = useState([])
  const [currentAlert, setCurrentAlert] = useState(
    tool?.alerts
      ? tool.alerts.filter((alert) => alert.alert_id == currentAlertId)[0]
      : null
  );
  const [selectMode, setSelectMode] = useState(false);
  const [selected, setSelected] = useState(selectedTemp);
  const [selectedCount, setSelectedCount] = useState(selectedTemp.length);
  const [lastSelected, setLastSelected] = useState(null);
  const [refreshing, setRefreshing] = useState(false);
  const [alertsLoading, setAlertsLoading] = useState(true);
  const [deleteAlerts, setDeleteAlerts] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [clearAlert, setClearAlert] = useState(false);
  const [clearLoading, setClearLoading] = useState(false);
  const [clearAlerts, setClearAlerts] = useState(false);
  const [clearsLoading, setClearsLoading] = useState(false);
  const [addAlert, setAddAlert] = useState(false);
  const [alertName, setAlertName] = useState("My Alert");
  const [channel, setChannel] = useState(0);
  const [criteria, setCriteria] = useState(0);
  const [value, setValue] = useState(channelValues[channel]);
  const [alertType, setAlertType] = useState(0);
  const [alertMode, setAlertMode] = useState(0);
  const [emailEnabled, setEmail] = useState(true);
  const [emailAddress, setEmailAddress] = useState(email);
  const [sms, setSms] = useState(false);
  const [app, setApp] = useState(true);
  const [customMessage, setCustomMessage] = useState("");
  const [hystTime, setHystTime] = useState("3600");
  const [triggerRemovedAlert, setTriggerRemovedAlert] = useState(true);
  const [error, setError] = useState("");
  const [addLoading, setAddLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [editAlert, setEditAlert] = useState(false);
  console.log("currentAlert:", currentAlert);
  // const [state, setState] = useState('base')
  const login = useGoogleLogin({
    scope: "https://www.googleapis.com/auth/drive.file",
    onSuccess: async (tokenResponse) => {
      console.log("tokenResponse:", tokenResponse);
      let token = tokenResponse.token_type + " " + tokenResponse.access_token;
      if (tool.mac) {
        await newSheet(
          {
            fileType: "googleSheetData",
            target: {
              type: "tool",
              mac: tool.mac,
              channels: selectedChannels,
              startTime: HelperService.getEpoch(startTime),
              stopTime: HelperService.getEpoch(stopTime),
            },
          },
          name,
          token
        );
      } else {
        await newSheet(
          {
            fileType: "googleSheetData",
            target: {
              type: "tool",
              share_id: tool.share_id,
              channels: selectedChannels,
              startTime: HelperService.getEpoch(startTime),
              stopTime: HelperService.getEpoch(stopTime),
            },
          },
          name,
          token
        );
      }
      setSheetLoading(false);
      setShowExport(false);
      return;
    },
  });
  // const navigate = useNavigate();
  let enabledCount = 0;
  enabled.forEach((attribute) => {
    if (attribute) enabledCount++;
  });
  let dayEnabled = true;
  let weekEnabled = true;
  let monthEnabled = true;
  const livelabel1 = "6Hr";
  const livelabel2 = "12Hr";
  const livelabel3 = "24Hr";
  let currentLiveLabel = livelabel1;
  if (scopeAdjustment) {
    if (scopeAdjustment["live"] == -2) {
      currentLiveLabel = livelabel3;
    } else if (scopeAdjustment["live"] == -1) {
      currentLiveLabel = livelabel2;
    } else {
      currentLiveLabel = livelabel1;
    }
  }
  const closestY = (x, y, yFunc, en, value) => {
    //NOW ONLY CHECKING IF ALL VALUES ARE NULL
    const array = [];
    let allNull = true;
    en.forEach((channel, index) => {
      if (channel && _.has(data[index][x], "y"))
        array.push([data[index][x].y, index + 1]);
    });
    array.forEach((data) => {
      if (data[0] != null && !isNaN(data[0])) {
        allNull = false; //found non null
      }
    });
    // const output = array.reduce((prev, curr) => {
    //     if(curr[0] != null){
    //         return Math.abs(yFunc(curr[0]) - y) < Math.abs(yFunc(prev[0]) - y) ? curr : prev
    //     }
    //     return prev

    // });
    if (value) {
      if (allNull) return true; //null
      return false; //yFunc(output[0])
    } else {
      return false; //output[1]
    }
  };

  const updateZoom = (zoom, position) => {
    console.log("Zoom:", zoom);
    console.log("Display Data:", displayDataZoomed);
    if (zoom < 1 || Math.round(zoom) == 1) zoom = 1;
    if (zoom > xdata.length / 2) zoom = Math.floor(xdata.length / 2);
    let size = Math.floor(xdata.length / zoom);
    if (zoom == 1) {
      if (!_.isEqual(displayData, displayDataZoomed)) {
        setChartUpdated(false);
        setDisplayDataZoomed(displayData);
        setXdataZoomed(xdata);
      }
    } else {
      zoomStartIndex = Math.max(position - size / 2, 0);
      zoomEndIndex = Math.min(position + size / 2, xdata.length - 1);
      if (zoomEndIndex == xdata.length - 1) {
        zoomStartIndex = Math.max(zoomEndIndex - size, 0);
      } else if (zoomStartIndex == 0) {
        zoomEndIndex = Math.min(zoomStartIndex + size, xdata.length - 1);
      }
      let tempDisplayData = _.cloneDeep(displayData);
      tempDisplayData.forEach((attribute) => {
        attribute.data = attribute.data.slice(zoomStartIndex, zoomEndIndex + 1);
      });
      setChartUpdated(false);
      setDisplayDataZoomed(tempDisplayData);
      setXdataZoomed(xdata.slice(zoomStartIndex, zoomEndIndex + 1));
    }
    setChartUpdated(true);
    lastZoomPosition = position;
  };
  useEffect(() => {
    if (clearLoading) {
      const clearAlertFunction = async () => {
        try {
          let result = await clearAlertAPI(tool, currentAlertId).then(
            (result) => result
          );
          let newAlerts = await getAlerts(tool).then((result) => result);
          if (newAlerts) {
            let tempAllSites = _.cloneDeep(allSites);
            if (tool?.mac) {
              tempAllSites[tool.mac].alerts = newAlerts;
            } else {
              tempAllSites[tool.share_id].alerts = newAlerts;
            }
            console.log("clearLoading Updating AllSites to ", tempAllSites);
            if (!_.isEqual(tempAllSites, allSites))
              handleSetAllSites(tempAllSites);
            updateCurrentAlert = true;
          }
          setClearLoading(false);
        } catch (error) {
          console.log("CLEAR ALERT ERROR:", error);
        }
      };
      clearAlertFunction();
    } else {
      setClearAlert(false);
    }
  }, [clearLoading]);

  useEffect(() => {
    if (clearsLoading) {
      const clearAlertsFunction = async () => {
        try {
          let result = await clearAlertsAPI(tool).then((result) => result);
          let newAlerts = await getAlerts(tool).then((result) => result);
          if (newAlerts) {
            let tempAllSites = _.cloneDeep(allSites);
            if (tool?.mac) {
              tempAllSites[tool.mac].alerts = newAlerts;
            } else {
              tempAllSites[tool.share_id].alerts = newAlerts;
            }
            console.log("clearsLoading Updating AllSites to ", tempAllSites);
            if (!_.isEqual(tempAllSites, allSites))
              handleSetAllSites(tempAllSites);
            updateCurrentAlert = true;
          }
          setClearsLoading(false);
        } catch (error) {
          console.log("CLEAR ALERTS ERROR:", error);
        }
      };
      clearAlertsFunction();
    } else {
      setClearAlerts(false);
    }
  }, [clearsLoading]);

  useEffect(() => {
    if (deleteLoading) {
      const deleteLoadingFunction = async () => {
        try {
          let result = await deleteAlertsAPI(
            _.has(tool, "mac")
              ? { mac: tool.mac }
              : { share_id: tool.share_id },
            selected
          ).then((result) => result);
          let newAlerts = await getAlerts(tool).then((result) => result);
          if (newAlerts) {
            let tempAllSites = _.cloneDeep(allSites);
            if (tool?.mac) {
              tempAllSites[tool.mac].alerts = newAlerts;
            } else {
              tempAllSites[tool.share_id].alerts = newAlerts;
            }
            console.log("deleteLoading Updating AllSites to ", tempAllSites);
            if (!_.isEqual(tempAllSites, allSites))
              handleSetAllSites(tempAllSites);
            updateCurrentAlert = true;
          }
          setDeleteLoading(false);
        } catch (error) {
          console.log("DELETE ERROR:", error);
        }
      };
      deleteLoadingFunction();
    } else {
      selectedTemp = [];
      if (!_.isEqual(selectedTemp, selected)) setSelected(selectedTemp);
      setSelectedCount(selectedTemp.length);
      setSelectMode(false);
      setDeleteAlerts(false);
    }
  }, [deleteLoading]);
  useEffect(() => {
    //Update currentAlert
    updateCurrentAlert = false;
    if (_.has(tool, "alerts"))
      setCurrentAlert(
        tool.alerts.filter((alert) => alert.alert_id == currentAlertId)[0]
      );
  }, [currentAlertId, updateCurrentAlert]);
  useEffect(() => {
    if (_.has(tool, "share_id")) {
      if (
        _.has(recipient, "recipientSettings") &&
        _.has(recipient.recipientSettings, "graphPropsDashboard") &&
        !_.isEmpty(recipient.recipientSettings.graphPropsDashboard)
      ) {
        if (
          !_.isEqual(
            recipient?.recipientSettings?.graphPropsDashboard?.enY,
            enabledAxis
          ) ||
          !_.isEqual(
            recipient?.recipientSettings?.graphPropsDashboard?.enX,
            xAxis
          ) ||
          !_.isEqual(
            recipient?.recipientSettings?.graphPropsDashboard?.start,
            customStartTime
          ) ||
          !_.isEqual(
            recipient?.recipientSettings?.graphPropsDashboard?.end,
            customStopTime
          )
        ) {
          updateGraphProps();
        }
        if (
          scope != "custom" &&
          tool?.recipientSettings?.graphPropsDashboard?.customScope
        ) {
          tempScopeAdjustment = scopeAdjustment;
          tempScopeAdjustment["custom"] = 0;
          setScopeAdjustment({ ...tempScopeAdjustment });
          setScope("custom");
        } else if (
          scope == "custom" &&
          !tool?.recipientSettings?.graphPropsDashboard?.customScope
        ) {
          tempScopeAdjustment = scopeAdjustment;
          tempScopeAdjustment["live"] = 0;
          setScopeAdjustment({ ...tempScopeAdjustment });
          setScope("live");
        }
      }
    } else if (_.has(tool, "mac")) {
      if (
        _.has(tool, "settings") &&
        _.has(tool.settings, "graphPropsDashboard") &&
        !_.isEmpty(tool.settings.graphPropsDashboard)
      ) {
        if (
          !_.isEqual(tool?.settings?.graphPropsDashboard?.enY, enabledAxis) ||
          !_.isEqual(tool?.settings?.graphPropsDashboard?.enX, xAxis) ||
          !_.isEqual(
            tool?.settings?.graphPropsDashboard?.start,
            customStartTime
          ) ||
          !_.isEqual(tool?.settings?.graphPropsDashboard?.end, customStopTime)
        ) {
          updateGraphProps();
        }
        if (
          scope != "custom" &&
          tool?.settings?.graphPropsDashboard?.customScope
        ) {
          tempScopeAdjustment = scopeAdjustment;
          tempScopeAdjustment["custom"] = 0;
          setScopeAdjustment({ ...tempScopeAdjustment });
          setScope("custom");
        } else if (
          scope == "custom" &&
          !tool?.settings?.graphPropsDashboard?.customScope
        ) {
          tempScopeAdjustment = scopeAdjustment;
          tempScopeAdjustment["live"] = 0;
          setScopeAdjustment({ ...tempScopeAdjustment });
          setScope("live");
        }
      }
    }
  }, [
    tool?.settings?.graphPropsDashboard,
    recipient?.recipientSettings?.graphPropsDashboard,
  ]);
  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      if (tab == 0) {
        console.log("RESIZE:", entries[0].contentRect);
        if (
          entries[0].contentRect.width > 0 &&
          entries[0].contentRect.height > 0
        ) {
          setWidth(entries[0].contentRect.width);
          setHeight(entries[0].contentRect.height);
          lastHeight = entries[0].contentRect.height;
          lastWidth = entries[0].contentRect.width;
        }
      }
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => ref.current && observer.unobserve(ref.current);
  }, [ref.current, tab, enabled, enabledAxis, fullscreen, macAddress]);
  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      if (tab == 1) {
        console.log("RESIZE:", entries[0].contentRect);
        if (
          entries[0].contentRect.width > 0 &&
          entries[0].contentRect.height > 0
        ) {
          setWidth(entries[0].contentRect.width);
          setHeight(entries[0].contentRect.height * 0.8);
          lastHeight = entries[0].contentRect.height * 0.8;
          lastWidth = entries[0].contentRect.width;
        }
      }
    });
    if (ref2.current) {
      observer.observe(ref2.current);
    }
    return () => ref2.current && observer.unobserve(ref2.current);
  }, [ref2.current, tab, macAddress]);
  useEffect(() => {
    console.log("Custom scope useEffect");
    setChartUpdated(false);
    tempData = [];
    setLoading(true);
    setTab(0);
    setToggle(true);
    setRecipient(
      tool?.share_id ? allSites["recipientShares"][macAddress] : null
    );
    setCurrentAlert(null);
    zoomScale = 1;
    lastZoomPosition = 1;
    if (!_.isEqual([true, true, true, true, true, true], enabledAxis))
      setEnabledAxis([true, true, true, true, true, true]);
    if (tool != undefined) {
      console.log("Tool:", tool);
      if (!ToolTypes.THP.localeCompare(tool.toolType)) {
        defaultEn = THP_ENABLED_ARRAY(tool, null);
        defaultEnAxis = THP_DEFAULT_Y_AXIS(tool.settings.channels);
        icons = THP_CHANNEL_ICONS;
      } else if (!ToolTypes.SDP.localeCompare(tool.toolType)) {
        defaultEn = SDP1_ENABLED_ARRAY(tool, null);
        defaultEnAxis = SDP1_DEFAULT_Y_AXIS(tool.settings.channels);
        icons = SDP1_CHANNEL_ICONS;
      } else if (!ToolTypes.THERMO_4_CH.localeCompare(tool.toolType)) {
        defaultEn = ST4C_ENABLED_ARRAY(tool, null);
        defaultEnAxis = ST4C_DEFAULT_Y_AXIS(tool.settings.channels);
        icons = ST4C_CHANNEL_ICONS;
      } else if (!ToolTypes.ANALOG_4_CH.localeCompare(tool.toolType)) {
        defaultEn = SA4C_ENABLED_ARRAY(tool, null);
        defaultEnAxis = SA4C_DEFAULT_Y_AXIS(tool.settings.channels);
        icons = SA4C_CHANNEL_ICONS;
      } else if (!ToolTypes.SWIM.localeCompare(tool.toolType)) {
        defaultEn = SSS1_ENABLED_ARRAY(tool, null);
        defaultEnAxis = SSS1_DEFAULT_Y_AXIS;
        icons = SSS1_CHANNEL_ICONS;
      } else if (!ToolTypes.CHEM.localeCompare(tool.toolType)) {
        defaultEn = SCP1_ENABLED_ARRAY(tool, null);
        icons = SCP1_CHANNEL_ICONS(tool);
        defaultEnAxis = SCP1_DEFAULT_Y_AXIS(tool.settings);
      }
    }
    if (!_.isEqual(defaultEn, enabled)) setEnabled(defaultEn);
    currentAlertId = null;
    graphDataPulled = false;
  }, [macAddress, tool?.mac, tool?.share_id]);
  useEffect(() => {
    zoomScale = 1;
    lastZoomPosition = 1;
    setChartUpdated(false);
    // setLoading(true)
    graphDataPulled = false;
  }, [scope, scopeAdjustment]);
  useEffect(() => {
    console.log("fullscreen Updating AllSites to ", {
      ...allSites,
      fullscreen: fullscreen,
    });
    if (!_.isEqual({ ...allSites, fullscreen: fullscreen }, allSites))
      handleSetAllSites({ ...allSites, fullscreen: fullscreen });
  }, [fullscreen]);
  useEffect(() => {
    graphDataPulled = false;
    if (customScope) {
      setScope("custom");
    } else {
      setScope("live");
    }
  }, [customScope, customStartTime, customStopTime]);
  useEffect(() => {
    setChartUpdated(false);
    setStartTime(
      displayDataZoomed[0]?.data != undefined &&
        displayDataZoomed[0]?.data.length > 0 &&
        displayDataZoomed[0]?.data[0]?.x != undefined
        ? displayDataZoomed[0]["data"][0]["x"]
        : undefined
    );
    setStopTime(
      displayDataZoomed[0]?.data[displayDataZoomed[0]?.data.length - 1] !=
        undefined
        ? displayDataZoomed[0]["data"][displayDataZoomed[0]?.data.length - 1][
            "x"
          ]
        : undefined
    );
    setStartTimeExport(
      displayDataZoomed[0]?.data != undefined &&
        displayDataZoomed[0]?.data.length > 0 &&
        displayDataZoomed[0]?.data[0]?.x != undefined
        ? displayDataZoomed[0]["data"][0]["x"]
        : undefined
    );
    setStopTimeExport(
      displayDataZoomed[0]?.data[displayDataZoomed[0]?.data.length - 1] !=
        undefined
        ? displayDataZoomed[0]["data"][displayDataZoomed[0]?.data.length - 1][
            "x"
          ]
        : undefined
    );
    setLoading(false);
    setChartUpdated(true);
  }, [displayDataZoomed]);
  // useEffect(()=>{
  //   setChartUpdated(false)
  // },[user,enabled,enabledAxis])
  useEffect(() => {
    setChartUpdated(false);
    console.log("Updating zoom: ", zoomScale, lastZoomPosition);
    updateZoom(zoomScale, lastZoomPosition);
  }, [displayData]);
  useEffect(() => {
    multiplier = (previewWidth - 20) / (xdataZoomed.length - 1);
  }, [xdataZoomed]);
  useEffect(() => {
    setValue(channelValues[channel]);
  }, [channel]);

  useEffect(() => {
    if (addLoading) {
      const addLoadingFunction = async () => {
        try {
          let settings;
          if (alertMode == 0) {
            settings = {
              triggerRemovedAlert: triggerRemovedAlert,
              alertType: ["single", "continuous"][alertType],
              alertName: alertName,
              smsNotification: sms,
              customMessage: customMessage,
              testField: channelNames[channel],
              hystTime: Number(hystTime),
              testCondition: ["GT", "LS"][criteria],
              testValue: Number(value),
              pushNotification: app,
              emailNotification: emailEnabled,
              emails: [emailAddress],
            };
          } else {
            settings = {
              triggerRemovedAlert: triggerRemovedAlert,
              alertType: ["single", "continuous"][alertType],
              alertName: alertName,
              smsNotification: sms,
              customMessage: customMessage,
              hystTime: Number(hystTime),
              pushNotification: app,
              emailNotification: emailEnabled,
              emails: [emailAddress],
            };
          }
          console.log("Alert Settings:", settings);
          let result = await addAlertAPI(
            tool,
            settings,
            [
              "sensorMode",
              "powerDisconnectMode",
              "lowBatteryMode",
              "offlineMode",
            ][alertMode]
          ).then((a) => a);
          let newAlerts = await getAlerts(tool).then((result) => result);
          if (newAlerts) {
            let tempAllSites = _.cloneDeep(allSites);
            if (tool?.mac) {
              tempAllSites[tool.mac].alerts = newAlerts;
            } else {
              tempAllSites[tool.share_id].alerts = newAlerts;
            }
            console.log("addLoading Updating AllSites to ", tempAllSites);
            if (!_.isEqual(tempAllSites, allSites))
              handleSetAllSites(tempAllSites);
            updateCurrentAlert = true;
          }
          setAddLoading(false);
        } catch (error) {
          console.log("ADD ERROR:", error);
        }
      };
      addLoadingFunction();
    } else {
      setAddAlert(false);
    }
  }, [addLoading]);
  useEffect(() => {
    if (updateLoading) {
      const updateLoadingFunction = async () => {
        try {
          let settings;
          if (alertMode == 0) {
            settings = {
              triggerRemovedAlert: triggerRemovedAlert,
              alertType: ["single", "continuous"][alertType],
              alertName: alertName,
              smsNotification: sms,
              customMessage: customMessage,
              testField: channelNames[channel],
              hystTime: Number(hystTime),
              testCondition: ["GT", "LS"][criteria],
              testValue: Number(value),
              pushNotification: app,
              emailNotification: emailEnabled,
              emails: [emailAddress],
            };
          } else {
            settings = {
              triggerRemovedAlert: triggerRemovedAlert,
              alertType: ["single", "continuous"][alertType],
              alertName: alertName,
              smsNotification: sms,
              customMessage: customMessage,
              hystTime: Number(hystTime),
              pushNotification: app,
              emailNotification: emailEnabled,
              emails: [emailAddress],
            };
          }
          let result = await updateAlert(
            currentAlert.mac
              ? { mac: currentAlert.mac }
              : { share_id: currentAlert.share_id },
            currentAlert.alert_id,
            settings
          );
          let newAlerts = await getAlerts(tool).then((result) => result);
          if (newAlerts) {
            let tempAllSites = _.cloneDeep(allSites);
            if (tool?.mac) {
              tempAllSites[tool.mac].alerts = newAlerts;
            } else {
              tempAllSites[tool.share_id].alerts = newAlerts;
            }
            console.log("updateLoading Updating AllSites to ", tempAllSites);

            if (!_.isEqual(tempAllSites, allSites))
              handleSetAllSites(tempAllSites);
            updateCurrentAlert = true;
          }
          setUpdateLoading(false);
        } catch (error) {
          console.log("UPDATE ERROR:", error);
        }
      };
      updateLoadingFunction();
    } else {
      setEditAlert(false);
    }
  }, [updateLoading]);

  useEffect(() => {
    // setLoading(true);
    setAlertsLoading(true);
    // if(xdata.length < 2){
    //   setLoading(true);
    //   setAlertsLoading(true)
    // }
    const getLiveGraphDataEffect = async () => {
      console.log("getLiveGraphData useEffect:", allSites);

      switch (tool.toolType) {
        case ToolTypes.THP:
          TOOL_CH_ENUM = THP_CH_ENUM;
          attributeArray = ["ts"].concat(...THP_CH_ENUM);
          break;
        case ToolTypes.SDP:
          TOOL_CH_ENUM = SDP1_CH_ENUM;
          attributeArray = ["ts"].concat(...SDP1_CH_ENUM);
          break;
        case ToolTypes.ANALOG_4_CH:
          TOOL_CH_ENUM = SA4C_CH_ENUM;
          attributeArray = ["ts"].concat(...SA4C_CH_ENUM);
          break;
        case ToolTypes.THERMO_4_CH:
          TOOL_CH_ENUM = ST4C_CH_ENUM;
          attributeArray = ["ts"].concat(...ST4C_CH_ENUM);
          break;
        case ToolTypes.SWIM:
          TOOL_CH_ENUM = SSS1_CH_ENUM;
          attributeArray = ["ts"].concat(...SSS1_CH_ENUM);
          break;
        case ToolTypes.CHEM:
          TOOL_CH_ENUM = SCP1_CH_ENUM;
          attributeArray = ["ts"].concat(...SCP1_CH_ENUM);
        default:
          break;
      }
      apiAttributes = attributeArray.join();
      if (!graphDataPulled) {
        console.log("getLiveGraphData useEffect:", allSites);
        await addGraphLiveData(
          { ...allSites },
          handleSetAllSites,
          user.signInUserSession.idToken.jwtToken,
          tool,
          scope,
          scopeAdjustment[scope],
          { start: customStartTime, end: customStopTime },
          null
        );
        graphDataPulled = true;
        let temp = [];
        if (_.has(tool, "data_id")) {
          console.log("getLiveGraphData useEffect:", { ...allSites });
          temp = getGraphData(tool.data_id, scope, attributeArray, {
            ...allSites,
          });
        } else if (_.has(tool, "share_id")) {
          temp = getGraphData(tool.share_id, scope, attributeArray, {
            ...allSites,
          });
        }
        if (temp.length > 0) tempData = temp;

        let tempDisplayData = [];
        console.log("Setting Display Data.");
        console.log("tempData:", tempData);
        console.log("enabled:", enabled);
        tempData.forEach((attribute, index) => {
          if (enabled[index]) {
            tempDisplayData[index] = attribute;
          } else {
            tempDisplayData[index] = attribute;
            attribute.data.forEach((point, i) => {
              tempDisplayData[index].data[i] = { x: point.x, y: null };
            });
          }
        });
        if (tool != undefined) {
          console.log("Tool:", tool);
          if (!ToolTypes.THP.localeCompare(tool.toolType)) {
            defaultEn = THP_ENABLED_ARRAY(tool, null);
            defaultEnAxis = THP_DEFAULT_Y_AXIS(tool.settings.channels);
            icons = THP_CHANNEL_ICONS;
          } else if (!ToolTypes.SDP.localeCompare(tool.toolType)) {
            defaultEn = SDP1_ENABLED_ARRAY(tool, null);
            defaultEnAxis = SDP1_DEFAULT_Y_AXIS(tool.settings.channels);
            icons = SDP1_CHANNEL_ICONS;
          } else if (!ToolTypes.THERMO_4_CH.localeCompare(tool.toolType)) {
            defaultEn = ST4C_ENABLED_ARRAY(tool, null);
            defaultEnAxis = ST4C_DEFAULT_Y_AXIS(tool.settings.channels);
            icons = ST4C_CHANNEL_ICONS;
          } else if (!ToolTypes.ANALOG_4_CH.localeCompare(tool.toolType)) {
            defaultEn = SA4C_ENABLED_ARRAY(tool, null);
            defaultEnAxis = SA4C_DEFAULT_Y_AXIS(tool.settings.channels);
            icons = SA4C_CHANNEL_ICONS;
          } else if (!ToolTypes.SWIM.localeCompare(tool.toolType)) {
            defaultEn = SSS1_ENABLED_ARRAY(tool, null);
            defaultEnAxis = SSS1_DEFAULT_Y_AXIS;
            icons = SSS1_CHANNEL_ICONS;
          } else if (!ToolTypes.CHEM.localeCompare(tool.toolType)) {
            defaultEn = SCP1_ENABLED_ARRAY(tool, null);
            icons = SCP1_CHANNEL_ICONS(tool);
            defaultEnAxis = SCP1_DEFAULT_Y_AXIS(tool.settings);
          }
          if (!_.isEqual(defaultEnAxis, enabledAxis))
            setEnabledAxis(defaultEnAxis);
          yAxisEnabledCount = 0;
          console.log("enabled:", enabled);
          console.log("enabledAxis:", enabledAxis);
          defaultEnAxis.forEach((axis) => {
            if (
              axis.enabled &&
              axis.channels.some((channel) => enabled[channel] == true)
            ) {
              console.log("Axis enabled!", axis);
              yAxisEnabledCount++;
            }
          });
          console.log("defaultEnAxis:", defaultEnAxis);

          if (
            tool.mac &&
            _.has(tool, "settings") &&
            _.has(tool.settings, "graphPropsDashboard") &&
            !_.isEmpty(tool.settings.graphPropsDashboard)
          ) {
            console.log("tool graph props");
            graphPropsDashboard = tool.settings.graphPropsDashboard;
            // defaultEn.forEach((en,index) => {
            //     if(en == false) graphPropsDashboard.en[index] = false
            // });
          } else {
            console.log("default tool graph props");
            graphPropsDashboard = {
              enX: true,
              start: null,
              end: null,
              en: defaultEn,
              enY: defaultEnAxis,
              enYCount: defaultEnAxis.length,
              currZoom: { x: 0, scale: 1 },
              customScope: false,
            };
          }
          console.log("defaultEn:", defaultEn);
        } else {
          console.log("Can't change Y Axis. Tool:", tool);
        }
        console.log("tempDisplayData:", tempDisplayData);
        setDisplayData(tempDisplayData);
        // setDisplayDataZoomed(tempDisplayData)
        setChartUpdated(true);
      }
      switch (tool.toolType) {
        case ToolTypes.THP:
          channels[0] = tool.settings.channels.sthp_temp.name;
          tempUnits[0] = tool.settings.channels.sthp_temp.unit;
          channelValues[0] = tool.convertedSensor.sthp_temp;
          channelNames[0] = "sthp_temp";
          channels[1] = tool.settings.channels.sthp_humid.name;
          tempUnits[1] = tool.settings.channels.sthp_humid.unit;
          channelValues[1] = tool.convertedSensor.sthp_humid;
          channelNames[1] = "sthp_humid";
          channels[2] = tool.settings.channels.sthp_pres.name;
          tempUnits[2] = tool.settings.channels.sthp_pres.unit;
          channelValues[2] = tool.convertedSensor.sthp_pres;
          channelNames[2] = "sthp_pres";
          channels[3] = tool.settings.channels.sthp_heatIndex.name;
          tempUnits[3] = tool.settings.channels.sthp_heatIndex.unit;
          channelValues[3] = tool.convertedSensor.sthp_heatIndex;
          channelNames[3] = "sthp_heatIndex";
          channels[4] = tool.settings.channels.sthp_dewPoint.name;
          tempUnits[4] = tool.settings.channels.sthp_dewPoint.unit;
          channelValues[4] = tool.convertedSensor.sthp_dewPoint;
          channelNames[4] = "sthp_dewPoint";
          break;
        case ToolTypes.SDP:
          channels[0] = tool.settings.channels.sdp1_temp1.name;
          tempUnits[0] = tool.settings.channels.sdp1_temp1.unit;
          channelValues[0] = tool.convertedSensor.sdp1_temp1;
          channelNames[0] = "sdp1_temp1";
          channels[1] = tool.settings.channels.sdp1_humid1.name;
          tempUnits[1] = tool.settings.channels.sdp1_humid1.unit;
          channelValues[1] = tool.convertedSensor.sdp1_humid1;
          channelNames[1] = "sdp1_humid1";
          channels[2] = tool.settings.channels.sdp1_pres1.name;
          tempUnits[2] = tool.settings.channels.sdp1_pres1.unit;
          channelValues[2] = tool.convertedSensor.sdp1_pres1;
          channelNames[2] = "sdp1_pres1";
          channels[3] = tool.settings.channels.sdp1_temp2.name;
          tempUnits[3] = tool.settings.channels.sdp1_temp2.unit;
          channelValues[3] = tool.convertedSensor.sdp1_temp2;
          channelNames[3] = "sdp1_temp2";
          channels[4] = tool.settings.channels.sdp1_humid2.name;
          tempUnits[4] = tool.settings.channels.sdp1_humid2.unit;
          channelValues[4] = tool.convertedSensor.sdp1_humid2;
          channelNames[4] = "sdp1_humid2";
          channels[5] = tool.settings.channels.sdp1_pres2.name;
          tempUnits[5] = tool.settings.channels.sdp1_pres2.unit;
          channelValues[5] = tool.convertedSensor.sdp1_pres2;
          channelNames[5] = "sdp1_pres2";
          break;
        case ToolTypes.ANALOG_4_CH:
          channels[0] = tool.settings.channels.sa4c_vC1.name;
          tempUnits[0] = tool.settings.channels.sa4c_vC1.linearScalingEnable
            ? tool.settings.channels.sa4c_vC1.linearScalingUnit
            : tool.settings.channels.sa4c_vC1.unit;
          channelValues[0] = tool.convertedSensor.sa4c_vC1;
          channelNames[0] = "sa4c_vC1";
          channels[1] = tool.settings.channels.sa4c_vC2.name;
          tempUnits[1] = tool.settings.channels.sa4c_vC2.linearScalingEnable
            ? tool.settings.channels.sa4c_vC2.linearScalingUnit
            : tool.settings.channels.sa4c_vC2.unit;
          channelValues[1] = tool.convertedSensor.sa4c_vC2;
          channelNames[1] = "sa4c_vC2";
          channels[2] = tool.settings.channels.sa4c_vC3.name;
          tempUnits[2] = tool.settings.channels.sa4c_vC3.linearScalingEnable
            ? tool.settings.channels.sa4c_vC3.linearScalingUnit
            : tool.settings.channels.sa4c_vC3.unit;
          channelValues[2] = tool.convertedSensor.sa4c_vC3;
          channelNames[2] = "sa4c_vC3";
          channels[3] = tool.settings.channels.sa4c_vC4.name;
          tempUnits[3] = tool.settings.channels.sa4c_vC4.linearScalingEnable
            ? tool.settings.channels.sa4c_vC4.linearScalingUnit
            : tool.settings.channels.sa4c_vC4.unit;
          channelValues[3] = tool.convertedSensor.sa4c_vC4;
          channelNames[3] = "sa4c_vC4";
          break;
        case ToolTypes.THERMO_4_CH:
          channels[0] = tool.settings.channels.st4c_tC1.name;
          tempUnits[0] = tool.settings.channels.st4c_tC1.unit;
          channelValues[0] = tool.convertedSensor.st4c_tC1;
          channelNames[0] = "st4c_tC1";
          channels[1] = tool.settings.channels.st4c_tC2.name;
          tempUnits[1] = tool.settings.channels.st4c_tC2.unit;
          channelValues[1] = tool.convertedSensor.st4c_tC2;
          channelNames[1] = "st4c_tC2";
          channels[2] = tool.settings.channels.st4c_tC3.name;
          tempUnits[2] = tool.settings.channels.st4c_tC3.unit;
          channelValues[2] = tool.convertedSensor.st4c_tC3;
          channelNames[2] = "st4c_tC3";
          channels[3] = tool.settings.channels.st4c_tC4.name;
          tempUnits[3] = tool.settings.channels.st4c_tC4.unit;
          channelValues[3] = tool.convertedSensor.st4c_tC4;
          channelNames[3] = "st4c_tC4";
          channels[4] = tool.settings.channels.st4c_tAmb.name;
          tempUnits[4] = tool.settings.channels.st4c_tAmb.unit;
          channelValues[4] = tool.convertedSensor.st4c_tAmb;
          channelNames[4] = "st4c_tAmb";
          break;
        case ToolTypes.SWIM:
          channels[0] = tool.settings.channels.sss1_ph.name;
          tempUnits[0] = tool.settings.channels.sss1_ph.unit;
          channelValues[0] = tool.convertedSensor.sss1_ph;
          channelNames[0] = "sss1_ph";
          channels[1] = tool.settings.channels.sss1_orp.name;
          tempUnits[1] = tool.settings.channels.sss1_orp.unit;
          channelValues[1] = tool.convertedSensor.sss1_orp;
          channelNames[1] = "sss1_orp";
          channels[2] = tool.settings.channels.sss1_salt.name;
          tempUnits[2] = tool.settings.channels.sss1_salt.unit;
          channelValues[2] = tool.convertedSensor.sss1_salt;
          channelNames[2] = "sss1_salt";
          channels[3] = tool.settings.channels.sss1_temp.name;
          tempUnits[3] = tool.settings.channels.sss1_temp.unit;
          channelValues[3] = tool.convertedSensor.sss1_temp;
          channelNames[3] = "sss1_temp";
          channels[4] = tool.settings.channels.sss1_tAmb.name;
          tempUnits[4] = tool.settings.channels.sss1_tAmb.unit;
          channelValues[4] = tool.convertedSensor.sss1_tAmb;
          channelNames[4] = "sss1_tAmb";
          channels[5] = tool.settings.channels.sss1_flow.name;
          tempUnits[5] = tool.settings.channels.sss1_flow.unit;
          channelValues[5] = tool.convertedSensor.sss1_flow;
          channelNames[5] = "sss1_flow";
          channels[6] = tool.settings.channels.sss1_duty.name;
          tempUnits[6] = tool.settings.channels.sss1_duty.unit;
          channelValues[6] = tool.convertedSensor.sss1_duty;
          channelNames[6] = "sss1_duty";
          break;
        case ToolTypes.CHEM:
          // let graphInfo = await SCP1_GRAPH_INFO(tool,tsIdx,attributes,file,fileRaw,xdata,channels,data,tempUnits,dataRawTemp)
          // channels =  graphInfo[0]
          // data =  graphInfo[1]
          // tempUnits =  graphInfo[2]
          // dataRawTemp =  graphInfo[3]
          break;
        default:
          break;
      }
      if (!addAlert && !editAlert) setValue(channelValues[channel]);
      // setLoading(false)
    };
    let apiAttributes;
    try {
      if (
        user &&
        tool &&
        _.has(user, "signInUserSession") &&
        _.has(user.signInUserSession, "idToken") &&
        _.has(user.signInUserSession.idToken, "jwtToken")
      ) {
        getLiveGraphDataEffect();
      } else {
        console.log("Can't pull data yet");
      }
    } catch (error) {
      console.log("unexpected error...");
    }
    if (tool?.toolType) {
      if (!ToolTypes.THP.localeCompare(tool.toolType)) {
        enabledChannels = THP_ENABLED_CHANNELS(tool, false);
      } else if (!ToolTypes.SDP.localeCompare(tool.toolType)) {
        enabledChannels = SDP1_ENABLED_CHANNELS(tool, false);
      } else if (!ToolTypes.THERMO_4_CH.localeCompare(tool.toolType)) {
        enabledChannels = ST4C_ENABLED_CHANNELS(tool, false);
      } else if (!ToolTypes.ANALOG_4_CH.localeCompare(tool.toolType)) {
        enabledChannels = SA4C_ENABLED_CHANNELS(tool, false);
      } else if (!ToolTypes.SWIM.localeCompare(tool.toolType)) {
        enabledChannels = SSS1_ENABLED_CHANNELS(tool, false);
      } else if (!ToolTypes.CHEM.localeCompare(tool.toolType)) {
        enabledChannels = SCP1_ENABLED_CHANNELS(tool, false);
      }
      tempChannelSelector = {};
      enabledChannels.forEach((channel) => {
        _.set(tempChannelSelector, channel, true);
      });
    }
    setAlertsLoading(false);
  }, [
    user,
    currentTool,
    enabled,
    tool,
    customStartTime,
    customStopTime,
    customScope,
    scope,
    enabledAxis,
    macAddress,
  ]);
  useEffect(() => {
    if (saveLoading) {
      try {
        if (tool.mac) {
          saveSession({
            target: {
              type: "tool",
              mac: tool.mac,
              channels: selectedChannels,
              startTime: HelperService.getEpoch(startTimeExport),
              stopTime: HelperService.getEpoch(stopTimeExport),
            },
            settings: { name: name },
          }).then(() => {
            setSaveLoading(false);
            setShowExport(false);
          });
        } else {
          saveSession({
            target: {
              type: "tool",
              share_id: tool.share_id,
              channels: selectedChannels,
              startTime: HelperService.getEpoch(startTimeExport),
              stopTime: HelperService.getEpoch(stopTimeExport),
            },
            settings: { name: name },
          }).then(() => {
            setSaveLoading(false);
            setShowExport(false);
          });
        }
        let updatedAllsites = { ...allSites, pullSessions: true };
        handleSetAllSites(updatedAllsites);
      } catch (error) {
        console.log("SAVE ERROR:", error);
      }
    }
  }, [saveLoading]);
  useEffect(() => {
    let fileType = "";
    if (formatList[format] == "CSV") fileType = "csv";
    if (formatList[format] == "Excel XLSX") fileType = "xlsx";
    if (formatList[format] == "PDF") fileType = "pdf";
    if (exportInitiated) {
      if (exportLoading) {
        try {
          if (tool.mac) {
            exportFile({
              fileType: fileType,
              target: {
                type: "tool",
                mac: tool.mac,
                channels: selectedChannels,
                startTime: HelperService.getEpoch(startTimeExport),
                stopTime: HelperService.getEpoch(stopTimeExport),
              },
              settings: { name: name },
            }).then((result) => {
              console.log("Export result:", result);
              setExportLoading(false);
              setShowExport(false);
              if (_.has(result, "downloadLink")) {
                window.open(result.downloadLink);
              }
            });
          } else {
            exportFile({
              fileType: fileType,
              target: {
                type: "tool",
                share_id: tool.share_id,
                channels: selectedChannels,
                startTime: HelperService.getEpoch(startTimeExport),
                stopTime: HelperService.getEpoch(stopTimeExport),
              },
              settings: { name: name },
            }).then((result) => {
              console.log("Export result:", result);
              setExportLoading(false);
              setShowExport(false);
              if (_.has(result, "downloadLink")) {
                window.open(result.downloadLink);
              }
            });
          }
        } catch (error) {
          console.log("EXPORT ERROR:", error);
        }
      } else {
        // onShare()
      }
    } else {
      console.log("NOT YET CODED");
    }
  }, [exportLoading]);

  //TODO NAV TO NEWLY SAVED SESSION
  // useEffect(() => {
  //     if(saveInitiated){
  //         dispatch(SessionActions.addGraphData(lastSession))
  //         NavigationService.navigate('Sessions',
  //         {screen: 'SessionOverview',params: {
  //             sessionID:lastSession,
  //             fullscreen: false,}})
  //     }
  //   }, [lastSession]);
  //

  if (tool === undefined) {
    console.log("TOOL UNDEFINED");
    return null;
  }
  function updatePositionX(x) {
    tempPositionX = x > -1 ? x * multiplier : x;
    setPositionX(tempPositionX);
    if (x >= 0) {
      setStartTimeExport(new Date(xdataZoomed[x] * 1000));
      if (tempPositionX >= tempPositionY && tempPositionY >= 0) {
        if (x < xdataZoomed.length - 1) {
          tempPositionY = tempPositionX + 1;
          setPositionY(tempPositionX + 1);
          setStopTimeExport(new Date(xdataZoomed[x + 1] * 1000));
        } else {
          tempPositionY = tempPositionX;
          setPositionY(tempPositionX);
          setStopTimeExport(new Date(xdataZoomed[x] * 1000));
        }
      }
    }
  }
  function updatePositionY(x) {
    tempPositionY = x > -1 ? x * multiplier : x;
    setPositionY(tempPositionY);
    if (x >= 0) {
      setStopTimeExport(new Date(xdataZoomed[x] * 1000));
      if (tempPositionY <= tempPositionX && tempPositionX >= 0) {
        if (x > 0) {
          tempPositionX = tempPositionY - 1;
          setPositionX(tempPositionY - 1);
          setStartTimeExport(new Date(xdataZoomed[x - 1] * 1000));
        } else {
          tempPositionX = tempPositionY;
          setPositionX(tempPositionY);
          setStartTimeExport(new Date(xdataZoomed[x] * 1000));
        }
      }
    }
  }
  function updateSliderTime(timeVal, start) {
    //start true stop false
    console.log("updating Slider time:", timeVal, "start:", start);
    let startEpoch = HelperService.getEpoch(startTimeExport);
    let stopEpoch = HelperService.getEpoch(stopTimeExport);
    let value = _.findIndex(xdataZoomed, function (o) {
      return o == timeVal;
    }); //index
    let closest;
    if (value == -1) {
      //Index not found? Find closest timestamp in data
      closest = xdataZoomed.reduce(function (prev, curr) {
        return Math.abs(curr - timeVal) < Math.abs(prev - timeVal)
          ? curr
          : prev;
      });
      value = _.findIndex(xdataZoomed, function (o) {
        return o == closest;
      });
    }
    console.log(
      "timeVal",
      timeVal,
      "min",
      min,
      "max",
      max,
      "startEpoch",
      startEpoch,
      "stopEpoch",
      stopEpoch,
      "value:",
      value
    );
    console.log("xdataZoomed length:", xdataZoomed.length);
    console.log("xdataZoomed:", xdataZoomed);
    if (start) {
      if (timeVal < min) {
        console.log("BEFORE MIN");
        updatePositionX(-1);
        setStartTimeExport(new Date(timeVal * 1000));
        if (timeVal > stopEpoch) {
          updatePositionY(-1);
          setStopTimeExport(new Date(timeVal * 1000));
        }
      } else if (timeVal > max) {
        console.log("AFTER MAX");
        updatePositionX(-2);
        setStartTimeExport(new Date(timeVal * 1000));
        if (timeVal > stopEpoch) {
          updatePositionY(-2);
          setStopTimeExport(new Date(timeVal * 1000));
        }
      } else {
        console.log("ON GRAPH");
        updatePositionX(Number(value));
        setStartTimeExport(new Date(timeVal * 1000));
      }
    } else {
      if (timeVal < min) {
        console.log("BEFORE MIN");
        updatePositionY(-1);
        setStopTimeExport(new Date(timeVal * 1000));
        if (timeVal < startEpoch) {
          updatePositionX(-1);
          setStartTimeExport(new Date(timeVal * 1000));
        }
      } else if (timeVal > max) {
        console.log("AFTER MAX");
        updatePositionY(-2);
        setStopTimeExport(new Date(timeVal * 1000));
        if (timeVal < startEpoch) {
          updatePositionX(-2);
          setStartTimeExport(new Date(timeVal * 1000));
        }
      } else {
        console.log("ON GRAPH");
        updatePositionY(Number(value));
        setStopTimeExport(new Date(timeVal * 1000));
      }
    }
  }
  const CustomDashedLines = (props) => {
    console.log("Custom Component Props:", props);

    return (
      <svg
        width={props.width + 20}
        height={props.height}
        x={-10}
        style={{ position: "absolute" }}
        onMouseDown={(event) => {
          console.log("MouseDown Event:", event);
          moving = true;
          let position = event.nativeEvent.layerX - 10;
          let newPosition = Math.round(position / multiplier);
          if (newPosition < 0) newPosition = 0;
          if (newPosition > xdataZoomed.length - 1)
            newPosition = xdataZoomed.length - 1;
          if (
            Math.abs(position - positionX) <= Math.abs(position - positionY)
          ) {
            currSlider = 0;
            updatePositionX(newPosition);
          } else {
            currSlider = 1;
            updatePositionY(newPosition);
          }
        }}
        onMouseMove={(event) => {
          if (moving) {
            console.log("MouseMove Event:", event);
            let position = event.nativeEvent.layerX - 10;
            let newPosition = Math.round(position / multiplier);
            if (newPosition < 0) newPosition = 0;
            if (newPosition > xdataZoomed.length - 1)
              newPosition = xdataZoomed.length - 1;
            if (currSlider == 0) {
              updatePositionX(newPosition);
            } else {
              updatePositionY(newPosition);
            }
          }
        }}
        onMouseLeave={(event) => {
          console.log("MouseUp Leave:", event);
          moving = false;
        }}
        onMouseUp={(event) => {
          console.log("MouseUp Event:", event);
          moving = false;
        }}
      >
        {/* Transparent rect to capture mouse events */}
        <rect
          x={0}
          y={0}
          width={props.width + 20}
          height={props.height}
          fill={Colors.transparent}
        />
        {/* Dashed line for the start time */}
        {positionX >= 0 ? (
          <line
            x1={positionX + 10}
            x2={positionX + 10}
            y1={0}
            y2={previewHeight - 35}
            stroke={Colors.lightGrey}
            strokeWidth="2"
            strokeDasharray={[6, 3]}
          />
        ) : (
          <></>
        )}
        {positionX >= 0 ? (
          <Icon
            svg={sliderIcon}
            size="s20"
            aspect={1}
            x={positionX}
            y={previewHeight - 35}
          />
        ) : (
          <></>
        )}
        {positionX == -1 ? (
          <Icon
            svg={leftIcon}
            size="s20"
            aspect={1}
            x={0}
            y={previewHeight - 35}
            color={Colors.vlightGrey}
          />
        ) : (
          <></>
        )}
        {positionX == -2 ? (
          <Icon
            svg={rightIcon}
            size="s20"
            aspect={1}
            x={previewWidth - 20}
            y={previewHeight - 35}
            color={Colors.vlightGrey}
          />
        ) : (
          <></>
        )}
        {/* Dashed line for the stop time */}
        {positionY >= 0 ? (
          <line
            x1={positionY + 10}
            x2={positionY + 10}
            y1={0}
            y2={previewHeight - 35}
            stroke={Colors.lightGrey}
            strokeWidth="2"
            strokeDasharray={[6, 3]}
          />
        ) : (
          <></>
        )}
        {positionY >= 0 ? (
          <Icon
            svg={sliderIcon}
            size="s20"
            aspect={1}
            x={positionY}
            y={previewHeight - 35}
          />
        ) : (
          <></>
        )}
        {positionY == -1 ? (
          <Icon
            svg={leftIcon}
            size="s20"
            aspect={1}
            x={0}
            y={previewHeight - 35}
            color={Colors.vlightGrey}
          />
        ) : (
          <></>
        )}
        {positionY == -2 ? (
          <Icon
            svg={rightIcon}
            size="s20"
            aspect={1}
            x={previewWidth - 20}
            y={previewHeight - 35}
            color={Colors.vlightGrey}
          />
        ) : (
          <></>
        )}
      </svg>
    );
  };
  function updateDateTime(value, start, time, exporting) {
    console.log(
      "\nvalue:",
      value,
      "\nstart:",
      start,
      "\ntime:",
      time,
      "\nDate:",
      new Date(value)
    );

    var tempDate;
    var year;
    var month;
    var date;
    var hrs;
    var mins;
    if (value == null || value == undefined) {
    } else {
      if (exporting) {
        if (start) {
          if (time) {
            tempDate = new Date(value); //new Date(value.nativeEvent.timestamp)
            hrs = tempDate.getHours();
            mins = tempDate.getMinutes();
            tempDate = new Date(value);
            tempDate.setHours(hrs);
            tempDate.setMinutes(mins);
            tempDate.setSeconds(0);
            console.log("Changing export start time to:", tempDate);
            updateSliderTime(HelperService.getEpoch(tempDate), true);
            setStartTimeExportPicker(false);
          } else {
            tempDate = new Date(value); //new Date(value.nativeEvent.timestamp)
            year = tempDate.getFullYear();
            month = tempDate.getMonth();
            date = tempDate.getDate();
            tempDate = new Date(value);
            tempDate.setFullYear(year);
            tempDate.setMonth(month);
            tempDate.setDate(date);
            console.log("Changing export start date to:", tempDate);
            updateSliderTime(HelperService.getEpoch(tempDate), true);
            setStartDateExportPicker(false);
          }
        } else {
          if (time) {
            tempDate = new Date(value); //new Date(value.nativeEvent.timestamp)
            hrs = tempDate.getHours();
            mins = tempDate.getMinutes();
            tempDate = new Date(value);
            tempDate.setHours(hrs);
            tempDate.setMinutes(mins);
            tempDate.setSeconds(0);
            console.log("Changing export stop time to:", tempDate);
            updateSliderTime(HelperService.getEpoch(tempDate), false);
            setStopTimeExportPicker(false);
          } else {
            tempDate = new Date(value); //new Date(value.nativeEvent.timestamp)
            year = tempDate.getFullYear();
            month = tempDate.getMonth();
            date = tempDate.getDate();
            tempDate = new Date(value);
            tempDate.setFullYear(year);
            tempDate.setMonth(month);
            tempDate.setDate(date);
            console.log("Changing export stop date to:", tempDate);
            updateSliderTime(HelperService.getEpoch(tempDate), false);
            setStopDateExportPicker(false);
          }
        }
      } else {
        if (start) {
          if (time) {
            tempDate = new Date(value); //new Date(value.nativeEvent.timestamp)
            hrs = tempDate.getHours();
            mins = tempDate.getMinutes();
            tempDate = new Date(value);
            tempDate.setHours(hrs);
            tempDate.setMinutes(mins);
            tempDate.setSeconds(0);
            console.log("Changing start time to:", tempDate);
            setCustomStartTime(tempDate);
            setStartTimePicker(false);
          } else {
            tempDate = new Date(value); //new Date(value.nativeEvent.timestamp)
            year = tempDate.getFullYear();
            month = tempDate.getMonth();
            date = tempDate.getDate();
            tempDate = new Date(value);
            tempDate.setFullYear(year);
            tempDate.setMonth(month);
            tempDate.setDate(date);
            console.log("Changing start date to:", tempDate);
            setCustomStartTime(tempDate);
            setStartDatePicker(false);
          }
        } else {
          if (time) {
            tempDate = new Date(value); //new Date(value.nativeEvent.timestamp)
            hrs = tempDate.getHours();
            mins = tempDate.getMinutes();
            tempDate = new Date(value);
            tempDate.setHours(hrs);
            tempDate.setMinutes(mins);
            tempDate.setSeconds(0);
            console.log("Changing stop time to:", tempDate);
            setCustomStopTime(tempDate);
            setStopTimePicker(false);
          } else {
            tempDate = new Date(value); //new Date(value.nativeEvent.timestamp)
            year = tempDate.getFullYear();
            month = tempDate.getMonth();
            date = tempDate.getDate();
            tempDate = new Date(value);
            tempDate.setFullYear(year);
            tempDate.setMonth(month);
            tempDate.setDate(date);
            console.log("Changing stop date to:", tempDate);
            setCustomStopTime(tempDate);
            setStopDatePicker(false);
          }
        }
      }
    }
  }
  // return <Typography.Title  level={4}>{macAddress}</Typography.Title >
  let content1;
  let content2;
  let content = (
    <Row.Overview
      tool={currentTool}
      toggle={toggle}
      setToggle={setToggle}
      usbPowered={
        _.has(tool, "toolSystem")
          ? tool.toolSystem.sysPowerState == "USB"
          : false
      }
      tab={tab}
      setTab={setTab}
      setNoScroll={setNoScroll}
      alerts={tool.alerts ? tool.alerts : null}
      clearSelection={() => {
        selectedTemp = [];
        if (!_.isEqual(selectedTemp, selected)) setSelected(selectedTemp);
        setSelectedCount(selectedTemp.length);
        setSelectMode(false);
      }}
    />
  );
  console.log("TAB:", tab);
  console.log("MAC:", macAddress);
  console.log("user:", user);
  if (user && macAddress) {
    console.log("TAB:", tab);
    if (tab == 0) {
      console.log("TAB 0");
      content = (
        <View
          style={{
            ...Helpers.fillCol,
            height: "100%",
            position: fullscreen ? "absolute" : "relative",
            x: 0,
            y: 0,
            width: "100%",
            overflow: "hidden",
          }}
        >
          {!fullscreen ? (
            <View>
              <Row.Overview
                tool={currentTool}
                toggle={toggle}
                setToggle={setToggle}
                usbPowered={
                  _.has(tool, "toolSystem")
                    ? tool.toolSystem.sysPowerState == "USB"
                    : false
                }
                tab={tab}
                setTab={setTab}
                setNoScroll={setNoScroll}
                alerts={tool.alerts ? tool.alerts : null}
                clearSelection={() => {
                  selectedTemp = [];
                  if (!_.isEqual(selectedTemp, selected))
                    setSelected(selectedTemp);
                  setSelectedCount(selectedTemp.length);
                  setSelectMode(false);
                }}
              />
              <Row.Section title={"Graph"}></Row.Section>
            </View>
          ) : (
            <></>
          )}
          {loading ? (
            <View style={{ ...Helpers.fillCenter, height: "100%" }}>
              <Spin size="large" />
            </View>
          ) : (
            <>
              <Row.ToolGraphOptions
                tool={true}
                navToGraphProps={() => {
                  setShowGraphProps(true);
                }}
                navToExport={
                  displayDataZoomed[0]?.data?.length < 2 ||
                  (tool.share_id &&
                    _.has(recipient, "recipientSettings") &&
                    recipient.recipientSettings.allowExport == false) ||
                  loading
                    ? null
                    : navToExport
                }
                // navToExport = {displayDataZoomed.length<2 ||
                //   (tool.share_id && _.has(recipient,'recipientSettings')  && recipient.recipientSettings.allowExport == false) || loading?null:
                //   navToExport}
                setFullscreen={setFullscreen}
                fullscreen={fullscreen}
                resetZoom={() => {
                  zoomScale = 1;
                  updateZoom(zoomScale, 1);
                }}
                zoom={
                  displayData[0]?.data?.length !=
                  displayDataZoomed[0]?.data?.length
                }
                start={startTime}
                end={stopTime}
              />
              <View style={{ display: "flex", flexGrow: 1 }}>
                {console.log("Current enabledAxis:", enabledAxis)}
                <View style={{ display: "flex", ...Helpers.row, flex: 1 }}>
                  {enabledAxis ? (
                    enabledAxis.map((axis, index) =>
                      Graph.AxisUsed(xdataZoomed.length, axis, enabled) &&
                      displayDataZoomed[0]?.data?.length > 1 &&
                      height ? (
                        <Graph.YAxis
                          style={{
                            backgroundColor:
                              axis.channels.length > 1
                                ? Colors.darkGrey
                                : colors[axis.channels[0]],
                          }}
                          // height={height}
                          isLoading={loading}
                          axis={axis}
                          toolType={tool.toolType}
                          maxData={graphData.maxData}
                          minData={graphData.minData}
                          index={index}
                          attributes={graphData.attributes}
                        />
                      ) : (
                        <></>
                      )
                    )
                  ) : (
                    <></>
                  )}
                </View>
                <div
                  ref={ref}
                  style={{ display: "flex", width: "100%", height: "100%" }}
                >
                  <div
                    style={{
                      display: "flex",
                      width: width,
                      height: height,
                      position: "absolute",
                      ...Helpers.row,
                    }}
                    onWheel={(e) => {
                      console.log("Zoom Index:", newTouchPosition);
                      if (e.deltaY < 0) {
                        console.log("Zoom In");
                        zooming = true;
                        zoomScale = Math.min(
                          Math.floor(xdata.length / 2),
                          zoomScale * 2
                        );
                        updateZoom(zoomScale, newTouchPosition);
                        zooming = false;
                      }
                      if (e.deltaY > 0) {
                        console.log("Zoom Out");
                        zooming = true;
                        zoomScale = Math.max(1, zoomScale / 2);
                        updateZoom(zoomScale, newTouchPosition);
                        zooming = false;
                      }
                    }}
                    onMouseDown={(event) => {
                      console.log("MouseDown Event:", event);
                      if (!_.isEqual(displayData, displayDataZoomed))
                        panning = true;
                    }}
                    onMouseMove={(event) => {
                      if (panning) {
                        console.log("MouseMove Event:", event);
                        let nextPosition;
                        if (event.movementX < 0) {
                          console.log("Pan Left");
                          nextPosition = Math.min(
                            lastZoomPosition + 1,
                            xdata.length - 1
                          );
                          updateZoom(zoomScale, nextPosition);
                        }
                        if (event.movementX > 0) {
                          console.log("Pan Right");
                          nextPosition = Math.max(0, lastZoomPosition - 1);
                          updateZoom(zoomScale, nextPosition);
                        }
                      }
                    }}
                    onMouseLeave={(event) => {
                      console.log("MouseUp Leave:", event);
                      panning = false;
                    }}
                    onMouseUp={(event) => {
                      console.log("MouseUp Event:", event);
                      panning = false;
                    }}
                  >
                    {console.log(
                      "dataPoints:",
                      displayDataZoomed[0]?.data?.length
                    )}
                    {/* {console.log('displayDataZoomed:',displayDataZoomed)} */}

                    {displayDataZoomed[0]?.data?.length > 1 &&
                    chartUpdated &&
                    !loading ? (
                      <ResponsiveLine
                        data={chartUpdated ? displayDataZoomed : []}
                        margin={{ top: 10, right: 20, bottom: 10, left: 10 }}
                        xScale={{
                          type: "time",
                          format: "native",
                          // precision: 'hour',
                        }}
                        yScale={{
                          type: "linear",
                          min: 0,
                          max: 1,
                          stacked: false,
                          reverse: false,
                        }}
                        gridYValues={[
                          0,
                          1 / 6,
                          (2 * 1) / 6,
                          (3 * 1) / 6,
                          (4 * 1) / 6,
                          (5 * 1) / 6,
                          1,
                        ]}
                        gridXValues={
                          xAxis
                            ? verticalLines
                            : [
                                new Date(xdataZoomed[0] * 1000),
                                new Date(
                                  xdataZoomed[xdataZoomed.length - 1] * 1000
                                ),
                              ]
                        }
                        yFormat=" >-.2f"
                        axisTop={null}
                        axisRight={null}
                        axisLeft={null}
                        axisBottom={null}
                        onMouseEnter={() => console.log("Mouse")}
                        sliceTooltip={({ slice }) => {
                          console.log("slice:", slice);
                          const apx = (size = 0, min = null) => {
                            if (min) {
                              if ((width / 750) * size > min) return min;
                            }
                            return (width / 750) * size;
                          };
                          const apy = (size = 0, min = null) => {
                            if (min) {
                              if ((height / 750) * size > min) return min;
                            }
                            return (height / 750) * size;
                          };
                          let counted = 0;
                          const countedIncrement = (enabled) => {
                            if (enabled) counted++;
                          };

                          let date = slice.points[0].data.x; //new Date(xdataZoomed[positionX]*1000)
                          console.log("Date:", date);
                          console.log(HelperService.formatDate(date, 1));
                          console.log(HelperService.formatTime(date, 0));
                          enabledCount = 0;
                          slice.points.forEach((attribute) => {
                            if (attribute) enabledCount++;
                          });
                          let longestData = 0;
                          let currentData = "";
                          let index;
                          let dataIndex = graphData.convertedData.findIndex(
                            (x) =>
                              new Date(x[0] * 1000).getTime() === date.getTime()
                          );
                          newTouchPosition = dataIndex;
                          console.log("dataIndex", dataIndex);
                          slice.points.forEach((attribute) => {
                            index = attributeArray.findIndex(
                              (x) => x == attribute.serieId
                            );
                            console.log(
                              "attribute.serieId:",
                              attribute.serieId
                            );
                            console.log("attributeArray:", attributeArray);
                            console.log("Index:", index);
                            console.log("tempUnits:", tempUnits);
                            if (
                              _.has(attribute.data, "y") &&
                              attribute.data.y != null &&
                              !isNaN(attribute.data.y)
                            ) {
                              currentData =
                                attribute.data.y.toFixed(2) +
                                " " +
                                tempUnits[index - 1];
                              if (currentData.length > longestData)
                                longestData = currentData.length;
                            }
                          });
                          console.log("currentData:", currentData);
                          let dateString =
                            HelperService.formatDate(date, 1) +
                            " " +
                            HelperService.formatTime(date, 0);
                          let timeLength = 8 * (dateString.length + 1);
                          let toolTipWidth = Math.max(
                            100,
                            Math.floor(8 * longestData),
                            timeLength
                          );
                          let toolTipHeight = Math.max(
                            apy(48 + enabledCount * 24),
                            80
                          );
                          console.log("toolTipWidth:", toolTipWidth);
                          if (!slice) return <></>;
                          return (
                            <svg
                              height={toolTipHeight}
                              width={toolTipWidth}
                              key="tooltip"
                            >
                              <g height={toolTipHeight} width={toolTipWidth}>
                                <rect
                                  rx={12} // borderRadius
                                  ry={12} // borderRadius
                                  width={toolTipWidth}
                                  height={toolTipHeight}
                                  stroke={Colors.light} //color
                                  fill={Colors.light} //color
                                />
                                <text
                                  x={apx(10)}
                                  y={toolTipHeight / (enabledCount + 2)}
                                  textAnchor="start"
                                  fill={Colors.lightGrey}
                                  fontSize={Fonts.small.fontSize}
                                  fontFamily="Inter-Regular"
                                >
                                  {HelperService.formatDate(date, 1)}
                                </text>
                                <text
                                  x={toolTipWidth - 10}
                                  y={toolTipHeight / (enabledCount + 2)}
                                  textAnchor="end"
                                  fill={Colors.lightGrey}
                                  fontSize={Fonts.small.fontSize}
                                  fontFamily="Inter-SemiBold"
                                >
                                  {HelperService.formatTime(date, 0)}
                                </text>
                                <line
                                  x1={apx(0)}
                                  x2={toolTipWidth} //Number(ticks.length)
                                  y1={toolTipHeight / (enabledCount + 2) + 4}
                                  y2={toolTipHeight / (enabledCount + 2) + 4}
                                  stroke={Colors.white}
                                  strokeWidth={2}
                                  // strokeDasharray={[6, 3]}
                                />
                                {console.log(
                                  "convertedData:",
                                  graphData.convertedData
                                )}
                                {attributeArray.map((attribute, i) => {
                                  // index = attributeArray.findIndex((x)=> x == attribute.serieId);
                                  index = slice.points.findIndex(
                                    (point) => point.serieId == attribute
                                  );
                                  console.log("attribute:", attribute);
                                  console.log("index:", index);
                                  console.log("i:", i);
                                  // graphData.convertedData
                                  return index > -1 && slice.points[index] ? (
                                    <>
                                      <text
                                        x={toolTipWidth - 10}
                                        y={
                                          (toolTipHeight / (enabledCount + 2)) *
                                            (counted + 2) +
                                          4
                                        }
                                        // y={apy(48 + (24*counted))}
                                        fontSize={Fonts.small.fontSize}
                                        // fontSize={width>height?apy(24):apx(24)}
                                        // fontWeight="bold"
                                        fill={colors[i - 1]}
                                        textAnchor="end"
                                        fontFamily="Inter-Regular"
                                      >
                                        {_.has(slice.points[index].data, "y") &&
                                        graphData.convertedData[dataIndex][i] !=
                                          null &&
                                        !isNaN(
                                          graphData.convertedData[dataIndex][i]
                                        )
                                          ? graphData.convertedData[dataIndex][
                                              i
                                            ].toFixed(2) +
                                            " " +
                                            tempUnits[i - 1]
                                          : "null"}
                                        {/* +" "+tempUnits[index] */}
                                      </text>
                                      {countedIncrement(slice.points[index])}
                                    </>
                                  ) : (
                                    <></>
                                  );
                                })}
                              </g>
                              {/* <g x={slice.x}>
                      {dataRaw.map((raw, index) => (
                          _.has(raw[positionX],"y") && enabled[index] && raw[positionX].y !=null && !isNaN(raw[positionX].y)?<circle
                              cy={slice.y}//y(data[index][positionX].y)
                              r={width>height?apy(4):apx(4)}
                              stroke={Colors.light}
                              strokeWidth={width>height?apy(1):apx(1)}
                              fill={Colors.darkGrey}
                          />:<></>                          
                      ))}      
                  </g> */}
                            </svg>
                          );
                        }}
                        colors={(d) => d.color}
                        enablePoints={false}
                        enableSlices="x"
                        // crosshairType="cross"
                        legends={[]}
                        enableCrosshair={false}
                        motionConfig="gentle"
                        layers={[
                          "grid",
                          "markers",
                          "axes",
                          "areas",
                          "crosshair",
                          "lines",
                          "points",
                          CustomPoint,
                          "slices",
                          "mesh",
                          "legends",
                        ]}
                        animate={false}
                      />
                    ) : (
                      <View style={{ ...Helpers.fillCenter, height: "100%" }}>
                        {console.log("displayDataZoomed:", displayDataZoomed)}
                        {loading || !chartUpdated ? (
                          <Spin size="large" />
                        ) : (
                          <Text
                            as={"xlarge"}
                            color={"darkGrey"}
                            weight={"bold"}
                          >
                            {_.isEqual(displayDataZoomed, []) ||
                            displayDataZoomed[0]?.data?.length == 0
                              ? "No Graph Data Available For This Scope"
                              : "Not Enough Data to Graph"}
                          </Text>
                        )}
                      </View>
                    )}
                  </div>
                </div>
              </View>
              {/* <Graph
        navigation = {navigation}
        toolType = {tool.toolType}
        icons={icons}
        // graphData = {graphData.updatedAt}
        channels = {channels}
        xdata ={xdataZoomed}
        data ={dataZoomed}
        dataRaw ={dataRawZoomed}
        enabled ={enabled}
        setEnabled ={setEnabled}
        enabledXAxis = {enabledXAxis}
        enabledAxis = {enabledAxis}
        setEnabledAxis = {setEnabledAxis}
        yAxisEnabledCount = {enalbledYAxisCount}
        isLoading = {isLoading}
        positionX = {positionX}
        positionY = {positionY}
        multiGraph = {true}
        panResponder = {panResponder}//{width>height?panResponderFull:panResponder}
        setFullscreen = {setFullscreen}
        axisWidth = {portraitAxisWidth}
        graphHeight ={graphHeight}
        width = {Math.min(width,height)}
        height= {Math.max(width,height)}
        time = {time}
        pinchZoomResponder = {width<height?pinchZoomResponderFull:pinchZoomResponder}
        zoom = {zoom}
        setZoom = {changeZoom}
        units = {units}
        scope = {scope}
        scopeAdjustment = {scopeAdjustment}
        setScope = {setScope}
        setScopeAdjustment = {setScopeAdjustment}
        timeElapsed = {timeElapsed}
        startOfData = {startOfData}
        hideChButtons = {true}
        maxData = {graphData.maxData}
        minData = {graphData.minData}
        attributes = {graphData.attributes}
      />   */}
              {console.log("XDATA:", xdataZoomed)}
              {console.log("verticalLines graph:", verticalLines)}
              {xAxis && xdataZoomed.length > 1 ? (
                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignSelf: "stretch",
                    height: 20,
                  }}
                >
                  <View
                    style={{ ...Helpers.row, width: 50 * yAxisEnabledCount }}
                  >
                    {enabledAxis ? (
                      enabledAxis.map((axis, index) =>
                        Graph.AxisUsed(xdataZoomed.length, axis, enabled) &&
                        xdataZoomed.length > 1 &&
                        !loading &&
                        displayDataZoomed[0]?.data?.length > 1 ? (
                          <View
                            style={{
                              display: "flex",
                              width: 50,
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Text
                              as="small"
                              weight="bold"
                              style={{
                                color:
                                  axis.channels.length > 1
                                    ? Colors.darkGrey
                                    : colors[axis.channels[0]],
                              }}
                            >
                              {tempUnits[axis.channels[0]]}
                            </Text>
                          </View>
                        ) : (
                          <></>
                        )
                      )
                    ) : (
                      <></>
                    )}
                  </View>
                  {xdataZoomed.length > 1 &&
                  !loading &&
                  displayDataZoomed[0]?.data?.length > 1 ? (
                    <Graph.XAxis
                      xdata={xdataZoomed}
                      isLoading={loading}
                      yAxisEnabledCount={yAxisEnabledCount}
                      axisWidth={50}
                      horizontalContentInset={{ right: 20, left: 10 }}
                      width={width}
                      landscape={true}
                      verticalLines={verticalLines}
                      setVerticalLines={(lines) => (verticalLines = lines)}
                    />
                  ) : (
                    <></>
                  )}
                </View>
              ) : (
                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignSelf: "stretch",
                    height: 20,
                  }}
                >
                  {enabledAxis ? (
                    enabledAxis.map((axis) =>
                      Graph.AxisUsed(xdataZoomed.length, axis, enabled) &&
                      xdataZoomed.length > 1 &&
                      !loading &&
                      displayDataZoomed[0]?.data?.length > 1 ? (
                        <View
                          style={{
                            display: "flex",
                            width: 50,
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Text
                            as="small"
                            weight="bold"
                            style={{
                              color:
                                axis.channels.length > 1
                                  ? Colors.darkGrey
                                  : colors[axis.channels[0]],
                            }}
                          >
                            {tempUnits[axis.channels[0]]}
                          </Text>
                        </View>
                      ) : (
                        <View style={{ height: 20 }} />
                      )
                    )
                  ) : (
                    <></>
                  )}
                </View>
              )}
              <View
                style={[
                  styles.scopeButtons,
                  styles.lightRowVertical,
                  Metrics.tinyHorizontalMargin,
                ]}
              >
                {customScope ? (
                  <View
                    style={[
                      styles.scopeButton,
                      styles.lightRowVertical,
                      { justifyContent: "center", width: "50%" },
                    ]}
                  >
                    <View
                      style={{
                        height: 38,
                        ...Metrics.tinyHorizontalMargin,
                        ...Helpers.center,
                      }}
                    >
                      <Text color={"secondary"} weight={"bold"}>
                        Custom Scope
                      </Text>
                    </View>
                  </View>
                ) : (
                  <View
                    style={{
                      flex: 1,
                      ...Helpers.row,
                      ...(dayEnabled
                        ? styles.scopeButtons
                        : styles.scopeButton),
                    }}
                  >
                    <View
                      style={{
                        ...Helpers.rowCross,
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {scope == "live" && scopeAdjustment["live"] >= -1 ? (
                        <View
                          style={{
                            cursor: "pointer",
                            ...Helpers.center,
                            flexDirection: "row",
                            height: "100%",
                          }}
                          onClick={() => {
                            scopeAdjustment["live"]--;
                            setScopeAdjustment({ ...scopeAdjustment });
                            setCookie(email, {
                              ...cookies[email],
                              minus: true,
                            });
                          }}
                        >
                          <Icon
                            style={[
                              Metrics.tinyHorizontalMargin,
                              Helpers.center,
                            ]}
                            svg={leftIcon}
                            size="xs"
                            color={Colors.lightGrey}
                          />
                        </View>
                      ) : (
                        <></>
                      )}
                      <View
                        style={{
                          cursor: "pointer",
                          width: 42,
                          height: 38,
                          ...Metrics.tinyHorizontalMargin,
                          ...Helpers.center,
                        }}
                        onClick={() => {
                          if (scope == "live") {
                            scopeAdjustment["live"] = 0;
                            setScopeAdjustment({ ...scopeAdjustment });
                            setCookie(email, { ...cookies[email], test: true });
                          } else {
                            setScope("live");
                            // setScopeAdjustment(...currentLiveLabel == livelabel3?-2:currentLiveLabel == livelabel2?-1:0)
                          }
                        }}
                      >
                        <Text
                          color={scope == "live" ? "secondary" : "darkGrey"}
                          weight={scope == "live" ? "bold" : "medium"}
                        >
                          {currentLiveLabel}
                        </Text>
                      </View>
                      {scope == "live" && scopeAdjustment["live"] < 0 ? (
                        <View
                          style={{
                            cursor: "pointer",
                            ...Helpers.center,
                            flexDirection: "row",
                            height: "100%",
                          }}
                          onClick={() => {
                            scopeAdjustment["live"]++;
                            setScopeAdjustment({ ...scopeAdjustment });
                          }}
                        >
                          <Icon
                            style={[
                              Metrics.tinyHorizontalMargin,
                              Helpers.center,
                            ]}
                            svg={rightIcon}
                            size="xs"
                            color={Colors.lightGrey}
                          />
                        </View>
                      ) : (
                        <></>
                      )}
                    </View>
                    {dayEnabled ? (
                      <View style={Helpers.rowCross}>
                        {scope == "day" && !startOfData ? (
                          <View
                            style={{
                              cursor: "pointer",
                              ...Helpers.center,
                              flexDirection: "row",
                              height: "100%",
                            }}
                            onClick={() => {
                              scopeAdjustment["day"]--;
                              setScopeAdjustment({ ...scopeAdjustment });
                            }}
                          >
                            <Icon
                              style={[
                                Metrics.tinyHorizontalMargin,
                                Helpers.center,
                              ]}
                              svg={leftIcon}
                              size="xs"
                              color={Colors.lightGrey}
                            />
                          </View>
                        ) : (
                          <></>
                        )}
                        <View
                          style={{
                            cursor: "pointer",
                            width: 38,
                            height: 38,
                            ...Metrics.tinyHorizontalMargin,
                            ...Helpers.center,
                          }}
                          onClick={() => {
                            if (scope == "day") {
                              scopeAdjustment["day"] = 0;
                              setScopeAdjustment({ ...scopeAdjustment });
                            } else {
                              setScope("day");
                            }
                          }}
                        >
                          <Text
                            color={scope == "day" ? "secondary" : "darkGrey"}
                            weight={scope == "day" ? "bold" : "medium"}
                          >
                            D
                          </Text>
                        </View>
                        {scope == "day" && scopeAdjustment["day"] < 0 ? (
                          <View
                            style={{
                              cursor: "pointer",
                              ...Helpers.center,
                              flexDirection: "row",
                              height: "100%",
                            }}
                            onClick={() => {
                              scopeAdjustment["day"]++;
                              setScopeAdjustment({ ...scopeAdjustment });
                            }}
                          >
                            <Icon
                              style={[
                                Metrics.tinyHorizontalMargin,
                                Helpers.center,
                              ]}
                              svg={rightIcon}
                              size="xs"
                              color={Colors.lightGrey}
                            />
                          </View>
                        ) : (
                          <></>
                        )}
                      </View>
                    ) : (
                      <></>
                    )}
                    {weekEnabled ? (
                      <View style={Helpers.rowCross}>
                        {scope == "week" && !startOfData ? (
                          <View
                            style={{
                              cursor: "pointer",
                              ...Helpers.center,
                              flexDirection: "row",
                              height: "100%",
                            }}
                            onClick={() => {
                              scopeAdjustment["week"]--;
                              setScopeAdjustment({ ...scopeAdjustment });
                            }}
                          >
                            <Icon
                              style={[
                                Metrics.tinyHorizontalMargin,
                                Helpers.center,
                              ]}
                              svg={leftIcon}
                              size="xs"
                              color={Colors.lightGrey}
                            />
                          </View>
                        ) : (
                          <></>
                        )}
                        <View
                          style={{
                            cursor: "pointer",
                            width: 38,
                            height: 38,
                            ...Metrics.tinyHorizontalMargin,
                            ...Helpers.center,
                          }}
                          onClick={() => {
                            if (scope == "week") {
                              scopeAdjustment["week"] = 0;
                              setScopeAdjustment({ ...scopeAdjustment });
                            } else {
                              setScope("week");
                            }
                          }}
                        >
                          <Text
                            color={scope == "week" ? "secondary" : "darkGrey"}
                            weight={scope == "week" ? "bold" : "medium"}
                          >
                            W
                          </Text>
                        </View>
                        {scope == "week" && scopeAdjustment["week"] < 0 ? (
                          <View
                            style={{
                              cursor: "pointer",
                              ...Helpers.center,
                              flexDirection: "row",
                              height: "100%",
                            }}
                            onClick={() => {
                              scopeAdjustment["week"]++;
                              setScopeAdjustment({ ...scopeAdjustment });
                            }}
                          >
                            <Icon
                              style={[
                                Metrics.tinyHorizontalMargin,
                                Helpers.center,
                              ]}
                              svg={rightIcon}
                              size="xs"
                              color={Colors.lightGrey}
                            />
                          </View>
                        ) : (
                          <></>
                        )}
                      </View>
                    ) : (
                      <></>
                    )}
                    {monthEnabled ? (
                      <View style={Helpers.rowCross}>
                        {scope == "month" && !startOfData ? (
                          <View
                            style={{
                              cursor: "pointer",
                              ...Helpers.center,
                              flexDirection: "row",
                              height: "100%",
                            }}
                            onClick={() => {
                              scopeAdjustment["month"]--;
                              setScopeAdjustment({ ...scopeAdjustment });
                            }}
                          >
                            <Icon
                              style={[
                                Metrics.tinyHorizontalMargin,
                                Helpers.center,
                              ]}
                              svg={leftIcon}
                              size="xs"
                              color={Colors.lightGrey}
                            />
                          </View>
                        ) : (
                          <></>
                        )}
                        <View
                          style={{
                            cursor: "pointer",
                            width: 38,
                            height: 38,
                            ...Metrics.tinyHorizontalMargin,
                            ...Helpers.center,
                          }}
                          onClick={() => {
                            if (scope == "month") {
                              scopeAdjustment["month"] = 0;
                              setScopeAdjustment({ ...scopeAdjustment });
                            } else {
                              setScope("month");
                            }
                          }}
                        >
                          <Text
                            color={scope == "month" ? "secondary" : "darkGrey"}
                            weight={scope == "month" ? "bold" : "medium"}
                          >
                            M
                          </Text>
                        </View>
                        {scope == "month" && scopeAdjustment["month"] < 0 ? (
                          <View
                            style={{
                              cursor: "pointer",
                              ...Helpers.center,
                              flexDirection: "row",
                              height: "100%",
                            }}
                            onClick={() => {
                              scopeAdjustment["month"]++;
                              setScopeAdjustment({ ...scopeAdjustment });
                            }}
                          >
                            <Icon
                              style={[
                                Metrics.tinyHorizontalMargin,
                                Helpers.center,
                              ]}
                              svg={rightIcon}
                              size="xs"
                              color={Colors.lightGrey}
                            />
                          </View>
                        ) : (
                          <></>
                        )}
                      </View>
                    ) : (
                      <></>
                    )}
                    <View
                      style={{
                        cursor: "pointer",
                        width: 38,
                        height: 38,
                        ...Metrics.tinyHorizontalMargin,
                        ...Helpers.center,
                      }}
                      onClick={() => {
                        setScope("all");
                      }}
                    >
                      <Text
                        color={scope == "all" ? "secondary" : "darkGrey"}
                        weight={scope == "all" ? "bold" : "medium"}
                      >
                        Max
                      </Text>
                    </View>
                  </View>
                )}
                {/* Enable Channel Buttons */}
                <View
                  style={[
                    styles.buttons,
                    styles.lightRow,
                    { overflow: "auto", width: "50%" },
                  ]}
                >
                  {tempData.length
                    ? tempData.map((attribute, index) => {
                        console.log("Current Attribute:", attribute);
                        return !_.isEmpty(attribute) &&
                          _.findIndex(enabledChannels, (ch) =>
                            _.isEqual(ch, attribute?.id)
                          ) >= 0 &&
                          icons[index] ? (
                          <View
                            key={"graphAtt" + index}
                            style={[
                              Helpers.row,
                              Metrics.tinyHorizontalMargin,
                              {
                                cursor: "pointer",
                                height: 38,
                                ...Helpers.center,
                              },
                            ]}
                            onClick={() => {
                              if (enabledCount == 1 && enabled[index]) {
                                //Don't allow empty graph
                              } else {
                                let newEnabled = [...enabled];
                                newEnabled[index] = !enabled[index];
                                graphDataPulled = false;
                                if (!_.isEqual(enabled, newEnabled))
                                  setEnabled(_.cloneDeep(newEnabled));
                                // console.log('newEnabled:',newEnabled)
                                // updateToolSettings(tool,{graphPropsDashboard:{}})
                              }
                            }}
                          >
                            <Icon
                              svg={icons[index]}
                              size="xs"
                              color={
                                enabled[index]
                                  ? colors[index]
                                  : Colors.vlightGrey
                              }
                            />
                            <View style={{ width: Spacing.sm }}></View>
                            <Text
                              color={enabled[index] ? "darkGrey" : "vlightGrey"}
                              style={{ whiteSpace: "nowrap" }}
                            >
                              {channels[index]}
                            </Text>
                          </View>
                        ) : (
                          <></>
                        );
                      })
                    : console.log("NO TEMP DATA")}
                </View>
              </View>
            </>
          )}
          <Modal
            title="Graph Properties"
            bodyStyle={{
              overflowY: "auto",
              height: fullscreen ? height * 0.8 : height,
            }}
            open={showGraphProps}
            footer={null}
            onCancel={() => setShowGraphProps(false)}
            onOk={() => setShowGraphProps(false)}
          >
            <Row.Section title={"X Axis"}></Row.Section>
            <Row.Toggle //Enable/Disable
              title="Custom Scope"
              icon={clockIcon}
              value={customScope}
              onValueChange={(value) => {
                setCustomScope(value);
              }}
            />
            {customScope ? (
              <>
                <Row.Time
                  title="Start"
                  icon={startIcon}
                  value={customStartTime}
                  timePickerVisible={startTimePicker}
                  datePickerVisible={startDatePicker}
                  onPressTime={() => setStartTimePicker(true)}
                  onPressDate={() => setStartDatePicker(true)}
                  onChangeTime={(value) =>
                    updateDateTime(value, true, true, false)
                  }
                  onChangeDate={(value) =>
                    updateDateTime(value, true, false, false)
                  }
                />
                <Row.Time
                  title="End"
                  icon={endIcon}
                  value={customStopTime}
                  timePickerVisible={stopTimePicker}
                  datePickerVisible={stopDatePicker}
                  onPressTime={() => setStopTimePicker(true)}
                  onPressDate={() => setStopDatePicker(true)}
                  onChangeTime={(value) =>
                    updateDateTime(value, false, true, false)
                  }
                  onChangeDate={(value) =>
                    updateDateTime(value, false, false, false)
                  }
                />
              </>
            ) : (
              <></>
            )}
            <Row.Toggle //Enable/Disable
              title="Display Time Axis"
              icon={clockIcon}
              value={xAxis}
              onValueChange={(value) => {
                setXAxis(value);
              }}
            />
            <Row.Section title={"Y Axis"}></Row.Section>
            {/* {console.log('Enabled Axis:',enabledAxis)} */}
            {console.log("graphData:", graphData)}
            {console.log(
              "MinData:",
              graphData.minData,
              "MaxData:",
              graphData.maxData
            )}
            {enabledAxis ? (
              enabledAxis.map((axis, index) => {
                if (axis != undefined && _.has(axis, "channels")) {
                  console.log("axis.channels:", axis.channels);
                  console.log("TOOL_CH_ENUM:", TOOL_CH_ENUM);
                }

                return axis != undefined && _.has(axis, "channels") ? (
                  <Row.YAxis //Enable/Disable
                    // enabled={axis.enabled}
                    name={axis.name}
                    channels={axis.channels}
                    icons={axis.channels.map((channel) => icons[channel])}
                    // auto={axis.auto}
                    min={
                      axis.auto && graphData.minData
                        ? Math.min(
                            ...axis.channels.reduce(
                              (prev, cur) =>
                                prev.concat(
                                  graphData.minData[
                                    _.findIndex(
                                      graphData.attributes,
                                      function (o) {
                                        return o == TOOL_CH_ENUM[cur];
                                      }
                                    )
                                  ]
                                ),
                              []
                            )
                          )
                        : axis.min
                    }
                    max={
                      axis.auto && graphData.maxData
                        ? Math.max(
                            ...axis.channels.reduce(
                              (prev, cur) =>
                                prev.concat(
                                  graphData.maxData[
                                    _.findIndex(
                                      graphData.attributes,
                                      function (o) {
                                        return o == TOOL_CH_ENUM[cur];
                                      }
                                    )
                                  ]
                                ),
                              []
                            )
                          )
                        : axis.max
                    }
                    axisIndex={index}
                    enabledAxis={enabledAxis}
                    setEnabledAxis={setEnabledAxis}
                    unit={
                      tool &&
                      tool.settings.channels[TOOL_CH_ENUM[axis.channels[0]]]
                        ?.linearScalingEnable
                        ? tool.settings.channels[TOOL_CH_ENUM[axis.channels[0]]]
                            .linearScalingUnit
                        : tool
                        ? tool.settings.channels[TOOL_CH_ENUM[axis.channels[0]]]
                            ?.unit
                        : ""
                    }
                  />
                ) : (
                  <></>
                );
              })
            ) : (
              <></>
            )}
          </Modal>
          <Modal
            title="Export"
            bodyStyle={{ height: fullscreen ? height * 0.8 : height }}
            open={showExport}
            footer={null}
            onCancel={() => setShowExport(false)}
            onOk={() => setShowExport(false)}
          >
            <View
              style={{
                ...Helpers.fillCol,
                width: "100%",
                height: fullscreen ? height * 0.8 - 60 : height - 60,
                overflowY: "auto",
              }}
            >
              <Row.Setting
                title="File Name"
                icon={fileIcon}
                setting={name}
                changeSetting={setName}
                setSetting={() => console.log("Changed Name")}
              />
              <Row.Section title="Preview" />
              <View
                style={{
                  paddingLeft: 40,
                  paddingRight: 40,
                  paddingTop: 5,
                  height: 45,
                  ...Helpers.mainSpaceBetween,
                  ...Helpers.row,
                  ...Helpers.rowCross,
                }}
              >
                <View
                  style={{
                    ...Helpers.rowCenter,
                    backgroundColor: Colors.light,
                    width: 81,
                    height: 24,
                    borderRadius: 8,
                  }}
                >
                  <Text numberOfLines={1} as="hint" color="lightGrey">
                    {startTimeExport
                      ? months[startTimeExport.getMonth()] +
                        " " +
                        startTimeExport.getDate() +
                        " "
                      : ""}
                  </Text>
                  <Text
                    numberOfLines={1}
                    as="hint"
                    weight="bold"
                    color="lightGrey"
                  >
                    {startTimeExport
                      ? startTimeExport.getHours() +
                        ":" +
                        (startTimeExport.getMinutes() >= 10 ? "" : "0") +
                        startTimeExport.getMinutes()
                      : ""}
                  </Text>
                </View>
                <View
                  style={{
                    ...Helpers.rowCenter,
                    backgroundColor: Colors.light,
                    width: 81,
                    height: 24,
                    borderRadius: 8,
                  }}
                >
                  <Text numberOfLines={1} as="hint" color="lightGrey">
                    {stopTimeExport
                      ? months[stopTimeExport.getMonth()] +
                        " " +
                        stopTimeExport.getDate() +
                        " "
                      : ""}
                  </Text>
                  <Text
                    numberOfLines={1}
                    as="hint"
                    weight="bold"
                    color="lightGrey"
                  >
                    {stopTimeExport
                      ? stopTimeExport.getHours() +
                        ":" +
                        (stopTimeExport.getMinutes() >= 10 ? "" : "0") +
                        stopTimeExport.getMinutes()
                      : ""}
                  </Text>
                </View>
              </View>
              <View style={Helpers.colCenter}>
                <View style={{ width: previewWidth, height: previewHeight }}>
                  <div
                    style={{ display: "flex", width: "100%", height: "100%" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: previewWidth,
                        height: previewHeight,
                        ...Helpers.row,
                      }}
                    >
                      <ResponsiveLine
                        data={chartUpdated ? displayDataZoomed : []}
                        margin={{ top: 10, right: 10, bottom: 25, left: 10 }}
                        xScale={{
                          type: "time",
                          format: "native",
                          // precision: 'hour',
                        }}
                        yScale={{
                          type: "linear",
                          min: 0,
                          max: 1,
                          stacked: false,
                          reverse: false,
                        }}
                        gridYValues={[
                          0,
                          1 / 6,
                          (2 * 1) / 6,
                          (3 * 1) / 6,
                          (4 * 1) / 6,
                          (5 * 1) / 6,
                          1,
                        ]}
                        gridXValues={
                          xAxis
                            ? verticalLines
                            : [
                                new Date(xdataZoomed[0] * 1000),
                                new Date(
                                  xdataZoomed[xdataZoomed.length - 1] * 1000
                                ),
                              ]
                        }
                        yFormat=" >-.2f"
                        axisTop={null}
                        axisRight={null}
                        axisLeft={null}
                        axisBottom={null}
                        colors={(d) => d.color}
                        enablePoints={false}
                        enableSlices={false}
                        enableCrosshair={false}
                        onClick={(point, event) => {
                          console.log("Point:", point);
                          console.log("Event:", event);
                        }}
                        legends={[]}
                        motionConfig="gentle"
                        layers={[
                          "grid",
                          "markers",
                          "axes",
                          "areas",
                          "crosshair",
                          "lines",
                          "points",
                          "slices",
                          "mesh",
                          "legends",
                          CustomDashedLines,
                        ]}
                        animate={false}
                      ></ResponsiveLine>
                    </div>
                  </div>
                </View>
                <Graph.XAxis
                  xdata={xdataZoomed}
                  yAxisEnabledCount={0}
                  isLoading={false}
                  axisWidth={0}
                  width={previewWidth}
                  horizontalContentInset={{ left: 0, right: 10 }}
                  landscape={true}
                  verticalLines={verticalLines}
                  setVerticalLines={(lines) => (verticalLines = lines)}
                />
              </View>
              <Row.Section title="Time Frame" />
              <Row.Time
                title="Start"
                value={startTimeExport}
                icon={startIcon}
                timePickerVisible={startTimeExportPicker}
                datePickerVisible={startDateExportPicker}
                onPressTime={() => setStartTimeExportPicker(true)}
                onPressDate={() => setStartDateExportPicker(true)}
                onChangeTime={(value) =>
                  updateDateTime(value, true, true, true)
                }
                onChangeDate={(value) =>
                  updateDateTime(value, true, false, true)
                }
              />
              <Row.Time
                title="End"
                value={stopTimeExport}
                icon={endIcon}
                timePickerVisible={stopTimeExportPicker}
                datePickerVisible={stopDateExportPicker}
                onPressTime={() => setStopTimeExportPicker(true)}
                onPressDate={() => setStopDateExportPicker(true)}
                onChangeTime={(value) =>
                  updateDateTime(value, false, true, true)
                }
                onChangeDate={(value) =>
                  updateDateTime(value, false, false, true)
                }
              />
              {channelSelector ? (
                <View>
                  <Row.Section title="Channels" />
                  {console.log("Enabled Channels:", enabledChannels)}
                  {console.log("Current Channels:", tool?.settings?.channels)}
                  {console.log("Current channelSelector:", channelSelector)}
                  {Object.keys(channelSelector).map((key, index) => {
                    console.log("key:", key);
                    console.log("value:", channelSelector[key]);
                    return (
                      <Row.Checkbox
                        title={_.get(tool.settings.channels, key)?.name}
                        icon={icons ? icons[index] : null}
                        channelColor={colors[index]}
                        value={channelSelector[key]}
                        onValueChange={(newValue) =>
                          updateChannel(key, newValue.target.checked)
                        }
                        noBorder={index == enabledChannels.length - 1}
                      />
                    );
                  })}
                </View>
              ) : (
                <></>
              )}
              <Row.Section title="Format" />
              <Row.Picker //Format
                title="Format"
                icon={fileIcon}
                values={formatList}
                value={formatList[format]}
                setValue={(value) => {
                  console.log("NEW VALUE:", value);
                  console.log(
                    "Calculated index:",
                    formatList.findIndex((item) => item == value)
                  );
                  setFormat(formatList.findIndex((item) => item == value));
                }}
                onPress={(value) => {}}
              />
            </View>
            <View
              style={{
                ...Metrics.verticalPadding,
                ...Helpers.row,
                justifyContent: "space-around",
                width: "100%",
              }}
            >
              {format == 0 ? ( //Stratus File
                <Button
                  text="Save to Folders"
                  style={{ width: "87%" }}
                  variant="primary"
                  isLoading={saveLoading}
                  onPress={() => {
                    setSaveLoading(true);
                  }}
                />
              ) : format == 1 || format == 2 || format == 3 ? ( //CSV, Excel, or PDF
                <Button
                  text="Export"
                  style={{ width: "87%" }}
                  variant="primary"
                  isLoading={exportLoading}
                  onPress={() => {
                    setExportLoading(true);
                    setExportInitiated(true);
                  }}
                />
              ) : format == 4 ? ( //Google Sheet
                <Button
                  text="Export"
                  style={{ width: "87%" }}
                  variant="primary"
                  isLoading={sheetLoading}
                  onPress={async () => {
                    setSheetLoading(true);
                    login();
                  }}
                />
              ) : (
                <></>
              )}
            </View>
          </Modal>
          {/* {(ToolTypes.THP.localeCompare(tool.toolType))?(<></>):(<THP.OverviewContainer currentTool ={tool} stats={stats} enabled={enabled} setEnabled={setEnabled}/>)}
      {(ToolTypes.SDP.localeCompare(tool.toolType))?(<></>):(<SDP1.OverviewContainer currentTool ={tool} stats={stats} enabled={enabled} setEnabled={setEnabled}/>)}
      {(ToolTypes.ANALOG_4_CH.localeCompare(tool.toolType))?(<></>):(<SA4C.OverviewContainer currentTool ={tool} stats={stats} enabled={enabled} setEnabled={setEnabled}/>)}
      {(ToolTypes.THERMO_4_CH.localeCompare(tool.toolType))?(<></>):(<ST4C.OverviewContainer currentTool ={tool} stats={stats} enabled={enabled} setEnabled={setEnabled}/>)}
      {(ToolTypes.SWIM.localeCompare(tool.toolType))?(<></>):(<SSS1.OverviewContainer currentTool ={tool} stats={stats} enabled={enabled} setEnabled={setEnabled}/>)}
      {(ToolTypes.CHEM.localeCompare(tool.toolType))?(<></>):(<SCP1.OverviewContainer currentTool ={tool} stats={stats} enabled={enabled} setEnabled={setEnabled}/>)}  */}
        </View>
      );
    } else if (tab == 1) {
      content1 = (
        <View style={{ ...Helpers.column, flex: 1, overflow: "clip" }}>
          <Row.Section title={"ALERTS"} />

          <View style={{ ...Helpers.fillCol, width: "100%", overflow: "auto" }}>
            {tool.share_id &&
            _.has(recipient, "recipientSettings") &&
            recipient.recipientSettings.allowAlert == false ? ( //No alerts
              <View>
                <Text>
                  Access to alerts not provided. For access, please ask sender
                  to allow 'Alerts' in their Share Tool settings.
                </Text>
              </View> //Alerts
            ) : !_.isEmpty(tool?.alerts) ? (
              tool.alerts.map((alert, index) => (
                <Row.Alert
                  onPress={() => {
                    currentAlertId = alert.alert_id;
                    setCurrentAlert(
                      tool.alerts.filter(
                        (alert) => alert.alert_id == currentAlertId
                      )[0]
                    );
                  }}
                  key={alert.alert_id}
                  alerts={tool.alerts}
                  alert={alert}
                  lastSelected={lastSelected}
                  channel={_.get(
                    tool.settings.channels,
                    alert.settings.testField
                  )}
                  addSelected={addSelected}
                  removeSelected={removeSelected}
                  selectMode={selectMode}
                  currentAlertId={currentAlertId}
                  selected={selected}
                  updateAlerts={async () => {
                    let newAlerts = await getAlerts(tool).then(
                      (result) => result
                    );
                    if (newAlerts) {
                      let tempAllSites = _.cloneDeep(allSites);
                      if (tool?.mac) {
                        tempAllSites[tool.mac].alerts = newAlerts;
                      } else {
                        tempAllSites[tool.share_id].alerts = newAlerts;
                      }
                      console.log(
                        "newAlerts Updating AllSites to ",
                        tempAllSites
                      );
                      if (!_.isEqual(tempAllSites, allSites))
                        handleSetAllSites(tempAllSites);
                      updateCurrentAlert = true;
                    }
                  }}
                />
              ))
            ) : alertsLoading && !refreshing ? (
              <View style={{ ...Helpers.colCross, flex: 1, height: "100%" }}>
                <Spin />
              </View>
            ) : (
              <View style={{ ...Helpers.colCross, ...Metrics.smallTopMargin }}>
                <img
                  style={{ height: 180, width: 180 }}
                  src={Images.noAlerts}
                  resizeMode={"contain"}
                />
                <Text
                  style={{ ...Metrics.mediumTopMargin, ...Helpers.textCenter }}
                  as="large"
                  color="primary"
                >
                  {
                    'You have not set any alerts.\nAdd an alert with the "Add Alert" buton below'
                  }
                </Text>
              </View>
            )}
          </View>
          {selectedCount > 0 ? (
            <View
              style={{
                ...Helpers.row,
                alignSelf: "flex-end",
                height: 60,
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Button
                style={{
                  width: "41%",
                  alignSelf: "center",
                  ...Metrics.verticalMargin,
                  ...Metrics.horizontalMargin,
                }}
                text="Clear Selection"
                variant="primary-transparent"
                onPress={() => {
                  selectedTemp = [];
                  if (!_.isEqual(selectedTemp, selected))
                    setSelected(selectedTemp);
                  setSelectedCount(selectedTemp.length);
                  setSelectMode(false);
                }}
              />
              <Button
                style={{
                  width: "41%",
                  alignSelf: "center",
                  ...Metrics.verticalMargin,
                  ...Metrics.horizontalMargin,
                }}
                text={selectedCount > 1 ? "Delete Alerts" : "Delete Alert"}
                variant="primary"
                onPress={() => {
                  setDeleteAlerts(true);
                }}
              />
            </View>
          ) : (
            <View
              style={{
                ...Helpers.row,
                alignSelf: "flex-end",
                height: 60,
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Button
                style={{
                  width: "41%",
                  alignSelf: "center",
                  ...Metrics.verticalMargin,
                  ...Metrics.horizontalMargin,
                }}
                text="Clear Alerts"
                variant="primary-transparent"
                onPress={() => {
                  setClearAlerts(true);
                }}
              />
              <Button
                style={{
                  width: "41%",
                  alignSelf: "center",
                  ...Metrics.verticalMargin,
                  ...Metrics.horizontalMargin,
                }}
                text="Add Alert"
                variant="primary"
                onPress={() => {
                  setAlertName("My Alert");
                  setChannel(0);
                  setCriteria(0);
                  setValue(channelValues[channel]);
                  setAlertType(0);
                  setAlertMode(0);
                  setEmail(true);
                  setEmailAddress(email);
                  setSms(false);
                  setApp(true);
                  setCustomMessage("");
                  setHystTime("3600");
                  setTriggerRemovedAlert(true);
                  setAddAlert(true);
                }}
              />
            </View>
          )}
        </View>
      );

      content2 = currentAlert ? (
        <View
          style={{
            ...Helpers.fillCol,
            flex: 1,
            overflow: "clip",
            height: "100%",
            borderLeft: "2px solid",
            borderLeftColor: Colors.light,
          }}
        >
          <Row.Section title={"Alert Summary"} />
          <Row.AlertSummary
            alert={currentAlert}
            tool={currentTool}
            onPress={() => {
              console.log("Edit Alert currentAlert:", currentAlert);
              console.log(
                "Alert Type:",
                _.findIndex(
                  ["single", "continuous"],
                  (a) => a == currentAlert.settings.alertType
                )
              );
              setAlertName(currentAlert.settings.alertName);
              setChannel(
                _.has(currentAlert.settings, "testField")
                  ? _.findIndex(
                      channelNames,
                      (a) => a == currentAlert.settings.testField
                    )
                  : 0
              );
              setCriteria(
                _.has(currentAlert.settings, "testCondition")
                  ? _.findIndex(
                      ["GT", "LS"],
                      (a) => a == currentAlert.settings.testCondition
                    )
                  : 0
              );
              setValue(
                _.has(currentAlert.settings, "testValue")
                  ? currentAlert.settings.testValue
                  : channelValues[channel]
              );
              setAlertType(
                _.findIndex(
                  ["single", "continuous"],
                  (a) => a == currentAlert.settings.alertType
                )
              );
              setAlertMode(
                _.findIndex(
                  [
                    "sensorMode",
                    "powerDisconnectMode",
                    "lowBatteryMode",
                    "offlineMode",
                  ],
                  (a) => a == currentAlert.alertMode
                )
              );
              setEmail(currentAlert.settings.emailNotification);
              setEmailAddress(
                _.has(currentAlert.settings, "emails")
                  ? currentAlert.settings.emails[0]
                  : ""
              );
              setSms(currentAlert.settings.smsNotification);
              setApp(currentAlert.settings.pushNotification);
              setCustomMessage(currentAlert.settings.customMessage);
              setHystTime(
                _.has(currentAlert.settings, "hystTime")
                  ? currentAlert.settings.hystTime
                  : "3600"
              );
              setTriggerRemovedAlert(currentAlert.settings.triggerRemovedAlert);
              setEditAlert(true);
            }}
          />
          <Row.Section title={"Alert Activity"} />
          <View style={{ ...Helpers.fillCol, width: "100%", overflow: "auto" }}>
            {!_.isEmpty(currentAlert.alertState.alertHistory) ? (
              currentAlert.alertState.alertHistory.map((event) => (
                <Row.AlertNotification event={event} />
              ))
            ) : (
              <Text style={Helpers.textCenter} as="small" color="darkGrey">
                {"No Alert History"}
              </Text>
            )}
          </View>
          {!_.isEmpty(currentAlert.alertState.alertHistory) ? (
            <View style={{ ...Helpers.rowCenter, height: 60, width: "100%" }}>
              <Button
                style={{
                  width: "80%",
                  alignSelf: "center",
                  ...Metrics.verticalMargin,
                  ...Metrics.horizontalMargin,
                }}
                text={"Clear Alert"}
                variant="primary"
                onPress={() => {
                  setClearAlert(true);
                }}
              />
            </View>
          ) : (
            <></>
          )}
        </View>
      ) : (
        <View style={{ ...Helpers.column, height: "100%", width: 0 }}>
          <Row.Section title={" "} />
        </View>
      );
      content = (
        <View style={{ height: "calc(100vh - 80px)", overflow: "clip" }}>
          <Row.Overview
            tool={currentTool}
            toggle={toggle}
            setToggle={setToggle}
            usbPowered={
              _.has(tool, "toolSystem")
                ? tool.toolSystem.sysPowerState == "USB"
                : false
            }
            tab={tab}
            setTab={setTab}
            setNoScroll={setNoScroll}
            alerts={tool.alerts ? tool.alerts : null}
            clearSelection={() => {
              selectedTemp = [];
              if (!_.isEqual(selectedTemp, selected)) setSelected(selectedTemp);
              setSelectedCount(selectedTemp.length);
              setSelectMode(false);
            }}
          />
          <View
            style={{
              ...Helpers.fillRow,
              height: "calc(100vh - 90px)",
              width: "100%",
            }}
          >
            <div
              ref={ref2}
              style={{ display: "flex", width: "100%", height: "100%" }}
            >
              {content1}
              {content2}
            </div>
          </View>
          <Alert
            visible={deleteAlerts}
            setVisible={setDeleteAlerts}
            title={selectedCount > 1 ? "Delete Alerts" : "Delete Alert"}
            text={
              selectedCount > 1
                ? "Are you sure you want to delete these alerts?"
                : "Are you sure you want to delete this alert?"
            }
            loading={deleteLoading}
            onPress={async () => {
              setDeleteLoading(true);
            }}
          />
          <Alert
            visible={clearAlert}
            setVisible={setClearAlert}
            title="Clear Alert Notifications"
            text={
              "Are you sure you want to clear the notifications of this alert?"
            }
            loading={clearLoading}
            onPress={() => {
              setClearLoading(true);
            }}
          />
          <Alert
            visible={clearAlerts}
            setVisible={setClearAlerts}
            title="Clear All Alert Notifications"
            text={
              "Are you sure you want to clear the notifications of all tool alerts?"
            }
            loading={clearsLoading}
            onPress={() => {
              setClearsLoading(true);
            }}
          />
          <Modal
            title="Add Alert"
            bodyStyle={{ height: height }}
            open={addAlert}
            footer={null}
            onCancel={() => setAddAlert(false)}
            onOk={() => setAddAlert(false)}
          >
            <View
              style={{
                ...Helpers.fillCol,
                width: "100%",
                height: height - 60,
                overflowY: "auto",
              }}
            >
              <Row.Setting
                title="Alert Name"
                icon={alertIcon}
                color={Colors.lightGrey}
                setting={alertName}
                changeSetting={setAlertName}
                setSetting={() => console.log("Changed Name")}
              />
              <Row.Picker //Channel
                title="Alert Mode"
                value={alertModeList[alertMode]}
                setValue={(value) => {
                  console.log("NEW VALUE:", value);
                  console.log(
                    "Calculated index:",
                    alertModeList.findIndex((item) => item == value)
                  );
                  setAlertMode(
                    alertModeList.findIndex((item) => item == value)
                  );
                }}
                icon={alertEditIcon}
                values={alertModeList}
                // selectedIndex={alertMode}
                onPress={(value) => {
                  // setAlertMode(value)
                }}
              />
              <Row.Setting
                title="Custom Message"
                icon={messageIcon}
                color={Colors.lightGrey}
                setting={customMessage}
                changeSetting={setCustomMessage}
                setSetting={() => console.log("Changed Message")}
              />
              <Row.Section title={"TRIGGERS"} />
              {alertMode == 0 ? (
                <View>
                  <Row.Picker //Channel
                    title="Channel"
                    icon={channelIcon}
                    value={channels[channel]}
                    setValue={(value) => {
                      console.log("NEW VALUE:", value);
                      console.log(
                        "Calculated index:",
                        channels.findIndex((item) => item == value)
                      );
                      setChannel(channels.findIndex((item) => item == value));
                    }}
                    values={channels}
                    // selectedIndex={channel}
                    onPress={(value) => {
                      // setChannel(value)
                    }}
                  />
                  <Row.TwoToggle
                    title="Criteria"
                    icon={criteriaIcon}
                    value={criteria}
                    onValueChange={(value) => setCriteria(value)}
                    option1={criteriaList[0]}
                    option2={criteriaList[1]}
                  />
                  <Row.Setting
                    title="Value"
                    icon={valueIcon}
                    numeric={true}
                    setting={value}
                    unit={tempUnits[channel]}
                    changeSetting={setValue}
                    setSetting={() => console.log("Changed Value")}
                  />
                </View>
              ) : (
                <></>
              )}

              <Row.TwoToggle
                title="Alert Type"
                icon={alertEditIcon}
                color={Colors.lightGrey}
                value={alertType}
                onValueChange={(value) => setAlertType(value)}
                option1={alertTypeList[0]}
                option2={alertTypeList[1]}
              />
              {alertType == 1 ? (
                <Row.Setting
                  title="Alert Frequency"
                  icon={pending}
                  numeric={true}
                  setting={hystTime}
                  changeSetting={setHystTime}
                  setSetting={() => console.log("Changed hystTime")}
                />
              ) : (
                <></>
              )}
              <Row.Toggle //Enable/Disable
                title="Trigger Removed Alert"
                noBorder={true}
                icon={alertRemoveIcon}
                value={triggerRemovedAlert}
                onValueChange={(value) => {
                  setTriggerRemovedAlert(value);
                }}
              />
              <Row.Section title={"ALERT METHODS"} />
              <Row.Toggle //Enable/Disable
                title="Email"
                icon={emailIcon}
                color={Colors.lightGrey}
                value={emailEnabled}
                onValueChange={(value) => {
                  setEmail(value);
                }}
              />
              {emailEnabled ? (
                <Row.Setting
                  title="Email Address"
                  icon={emailIcon}
                  color={Colors.lightGrey}
                  setting={emailAddress}
                  changeSetting={setEmailAddress}
                  setSetting={() => {
                    if (emailAddress != "") setError("");
                  }}
                >
                  {error != "" ? (
                    <Text color="error" weight="light">
                      {error}
                    </Text>
                  ) : (
                    <></>
                  )}
                </Row.Setting>
              ) : (
                <></>
              )}
              <Row.Toggle //Enable/Disable
                title="SMS"
                icon={phoneIcon}
                color={Colors.lightGrey}
                value={sms}
                onValueChange={(value) => {
                  setSms(value);
                }}
              />
              <Row.Toggle //Enable/Disable
                title="App Notification"
                icon={alertIcon}
                color={Colors.lightGrey}
                value={app}
                onValueChange={(value) => {
                  setApp(value);
                }}
              />
            </View>
            <View style={{ ...Helpers.center, height: 60 }}>
              <Button
                style={{ width: "87%" }}
                text="Add Alert"
                variant="primary"
                isLoading={addLoading}
                onPress={async () => {
                  await setError("");
                  if (await errorCheck()) {
                    setAddLoading(true);
                  }
                }}
              />
            </View>
          </Modal>
          <Modal
            title="Edit Alert"
            bodyStyle={{ height: height }}
            open={editAlert}
            footer={null}
            onCancel={() => setEditAlert(false)}
            onOk={() => setEditAlert(false)}
          >
            <View
              style={{
                ...Helpers.fillCol,
                width: "100%",
                height: height - 60,
                overflowY: "auto",
              }}
            >
              <Row.Setting
                title="Alert Name"
                icon={alertIcon}
                color={Colors.lightGrey}
                setting={alertName}
                changeSetting={setAlertName}
                setSetting={() => console.log("Changed Name")}
              />
              <Row.Setting
                title="Custom Message"
                icon={messageIcon}
                color={Colors.lightGrey}
                setting={customMessage}
                changeSetting={setCustomMessage}
                setSetting={() => console.log("Changed Message")}
              />
              <Row.Section title={"TRIGGERS"} />
              {alertMode == 0 ? (
                <View>
                  <Row.Picker //Channel
                    title="Channel"
                    icon={channelIcon}
                    value={channels[channel]}
                    setValue={(value) => {
                      console.log("NEW VALUE:", value);
                      console.log(
                        "Calculated index:",
                        channels.findIndex((item) => item == value)
                      );
                      setChannel(channels.findIndex((item) => item == value));
                    }}
                    values={channels}
                    // selectedIndex={channel}
                    onPress={(value) => {
                      // setChannel(value)
                    }}
                  />
                  <Row.TwoToggle
                    title="Criteria"
                    icon={criteriaIcon}
                    value={criteria}
                    onValueChange={(value) => setCriteria(value)}
                    option1={criteriaList[0]}
                    option2={criteriaList[1]}
                  />
                  <Row.Setting
                    title="Value"
                    icon={valueIcon}
                    numeric={true}
                    setting={value}
                    unit={tempUnits[channel]}
                    changeSetting={setValue}
                    setSetting={() => console.log("Changed Value")}
                  />
                </View>
              ) : (
                <></>
              )}

              <Row.TwoToggle
                title="Alert Type"
                icon={alertEditIcon}
                color={Colors.lightGrey}
                value={alertType}
                onValueChange={(value) => setAlertType(value)}
                option1={alertTypeList[0]}
                option2={alertTypeList[1]}
              />
              {alertType == 1 ? (
                <Row.Setting
                  title="Alert Frequency"
                  icon={pending}
                  numeric={true}
                  setting={hystTime}
                  changeSetting={setHystTime}
                  setSetting={() => console.log("Changed hystTime")}
                />
              ) : (
                <></>
              )}
              <Row.Toggle //Enable/Disable
                title="Trigger Removed Alert"
                noBorder={true}
                icon={alertRemoveIcon}
                value={triggerRemovedAlert}
                onValueChange={(value) => {
                  setTriggerRemovedAlert(value);
                }}
              />
              <Row.Section title={"ALERT METHODS"} />
              <Row.Toggle //Enable/Disable
                title="Email"
                icon={emailIcon}
                color={Colors.lightGrey}
                value={emailEnabled}
                onValueChange={(value) => {
                  setEmail(value);
                }}
              />
              {emailEnabled ? (
                <Row.Setting
                  title="Email Address"
                  icon={emailIcon}
                  color={Colors.lightGrey}
                  setting={emailAddress}
                  changeSetting={setEmailAddress}
                  setSetting={() => {
                    if (emailAddress != "") setError("");
                  }}
                >
                  {error != "" ? (
                    <Text color="error" weight="light">
                      {error}
                    </Text>
                  ) : (
                    <></>
                  )}
                </Row.Setting>
              ) : (
                <></>
              )}
              <Row.Toggle //Enable/Disable
                title="SMS"
                icon={phoneIcon}
                color={Colors.lightGrey}
                value={sms}
                onValueChange={(value) => {
                  setSms(value);
                }}
              />
              <Row.Toggle //Enable/Disable
                title="App Notification"
                icon={alertIcon}
                color={Colors.lightGrey}
                value={app}
                onValueChange={(value) => {
                  setApp(value);
                }}
              />
            </View>
            <View style={{ ...Helpers.center, height: 60 }}>
              <Button
                style={{ width: "87%" }}
                text="Update Alert"
                variant="primary"
                isLoading={updateLoading}
                onPress={async () => {
                  await setError("");
                  if (await errorCheck()) {
                    setUpdateLoading(true);
                  }
                }}
              />
            </View>
          </Modal>
        </View>
      );
    } else {
      content = (
        <>
          <Row.Overview
            tool={currentTool}
            toggle={toggle}
            setToggle={setToggle}
            usbPowered={
              _.has(currentTool, "toolSystem")
                ? currentTool.toolSystem.sysPowerState == "USB"
                : false
            }
            tab={tab}
            setTab={setTab}
            setNoScroll={setNoScroll}
            alerts={currentTool.alerts ? currentTool.alerts : null}
            clearSelection={() => {
              selectedTemp = [];
              if (!_.isEqual(selectedTemp, selected)) setSelected(selectedTemp);
              setSelectedCount(selectedTemp.length);
              setSelectMode(false);
            }}
          />
          <Row.Section title={"Settings"}></Row.Section>
          <ToolSettings />
        </>
      );
    }
    console.log("RETURNING CONTENT:", content);
    return content;
  } else {
    console.log("MAC:", macAddress);
    console.log("user:", user);
    return <Row.Section title={"No User or MAC"}></Row.Section>;
  }
}
Site.whyDidYouRender = {
  logOnDifferentValues: true,
  customName: "SiteWDYR",
};

export default Site;
